import { Injectable, ɵɵdefineInjectable, ɵɵinject, Component, NgModule, ViewEncapsulation, EventEmitter, Output, Directive, TemplateRef, ViewContainerRef, Input, LOCALE_ID, enableProdMode } from '@angular/core';
import { HttpHeaders, HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule, registerLocaleData } from '@angular/common';
import { Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService, TranslateLoader } from '@ngx-translate/core';
import { Router, ActivatedRoute, RouterModule, NavigationEnd, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { filter, map, take, catchError, switchMap, finalize } from 'rxjs/operators';
import { OAuthService, OAuthModule } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { BehaviorSubject, forkJoin, throwError, from } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { AvatarModule } from 'ngx-avatar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DropdownModule } from 'primeng/dropdown';
import { MenubarModule } from 'primeng/menubar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ProgressBarModule } from 'primeng/progressbar';
import { SidebarModule } from 'primeng/sidebar';
import { SlideMenuModule } from 'primeng/slidemenu';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import localePt from '@angular/common/locales/pt';
import localePtExtra from '@angular/common/locales/extra/pt';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { fromFetch } from 'rxjs/fetch';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/mapa-enviroment.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Referencia para a configuração global
 * @type {?}
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from 'angular-oauth2-oidc';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from 'primeng/toast';
import * as ɵngcc6 from 'primeng/panel';
import * as ɵngcc7 from 'primeng/inputtext';
import * as ɵngcc8 from '@angular/common';
import * as ɵngcc9 from 'primeng/button';
import * as ɵngcc10 from 'primeng/message';
import * as ɵngcc11 from '@ngx-translate/core';
import * as ɵngcc12 from 'primeng/breadcrumb';
import * as ɵngcc13 from 'primeng/progressbar';
import * as ɵngcc14 from '@angular/cdk/layout';
import * as ɵngcc15 from 'ngx-avatar';
import * as ɵngcc16 from 'primeng/menubar';
import * as ɵngcc17 from 'primeng/dropdown';
import * as ɵngcc18 from 'primeng/sidebar';
import * as ɵngcc19 from 'primeng/panelmenu';
import * as ɵngcc20 from 'primeng/autocomplete';

function AuthComponent_p_message_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-message", 13);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("text", ɵngcc0.ɵɵpipeBind1(1, 1, "CORE.AUTH.REQUIRED"));
} }
function AuthComponent_p_message_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-message", 13);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("text", ɵngcc0.ɵɵpipeBind1(1, 1, "CORE.AUTH.REQUIRED"));
} }
const _c0 = function () { return { marginTop: "80px" }; };
function PublicLayoutComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "mapa-header");
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelement(3, "router-outlet");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.ambiente);
} }
function HeaderComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelement(2, "ngx-avatar", 13);
    ɵngcc0.ɵɵelementStart(3, "span", 14);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("name", ctx_r1.usuario.nome);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.usuario.nome);
} }
function HeaderComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "h3");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.pageTitle);
} }
const _c1 = function (a0) { return { "handset": a0 }; };
function NavBarComponent_div_1_p_dropdown_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-dropdown", 8);
    ɵngcc0.ɵɵlistener("onChange", function NavBarComponent_div_1_p_dropdown_3_Template_p_dropdown_onChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.atualizarIdioma(); })("ngModelChange", function NavBarComponent_div_1_p_dropdown_3_Template_p_dropdown_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.language = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.language)("options", ctx_r2.languages)("styleClass", "mapa-lang");
} }
function NavBarComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelement(1, "p-menubar", 4);
    ɵngcc0.ɵɵelementStart(2, "mapa-search-nav-item", 5);
    ɵngcc0.ɵɵlistener("changeRouter", function NavBarComponent_div_1_Template_mapa_search_nav_item_changeRouter_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.fecharMenuLateral($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, NavBarComponent_div_1_p_dropdown_3_Template, 1, 3, "p-dropdown", 6);
    ɵngcc0.ɵɵelement(4, "p-menubar", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("model", ctx_r0.nav)("styleClass", "mapa-menubar");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.languages.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("autoDisplay", false)("model", ctx_r0.navRight)("styleClass", "mapa-menubar");
} }
function NavBarComponent_div_3_p_dropdown_13_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-dropdown", 19);
    ɵngcc0.ɵɵlistener("onChange", function NavBarComponent_div_3_p_dropdown_13_Template_p_dropdown_onChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.atualizarIdioma(); })("ngModelChange", function NavBarComponent_div_3_p_dropdown_13_Template_p_dropdown_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.language = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.language)("options", ctx_r8.languages);
} }
function NavBarComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "p-sidebar", 10);
    ɵngcc0.ɵɵlistener("visibleChange", function NavBarComponent_div_3_Template_p_sidebar_visibleChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.exibirMenuLateral = $event; });
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelement(4, "ngx-avatar", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵelementStart(6, "span", 13);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 14);
    ɵngcc0.ɵɵelementStart(10, "div", 15);
    ɵngcc0.ɵɵelementStart(11, "mapa-search-nav-item", 5);
    ɵngcc0.ɵɵlistener("changeRouter", function NavBarComponent_div_3_Template_mapa_search_nav_item_changeRouter_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.fecharMenuLateral($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 16);
    ɵngcc0.ɵɵtemplate(13, NavBarComponent_div_3_p_dropdown_13_Template, 1, 2, "p-dropdown", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(14, "p-panelMenu", 4);
    ɵngcc0.ɵɵelement(15, "p-panelMenu", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "button", 18);
    ɵngcc0.ɵɵlistener("click", function NavBarComponent_div_3_Template_button_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.exibirMenuLateral = true; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "h1");
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("visible", ctx_r1.exibirMenuLateral)("showCloseIcon", false)("styleClass", "mapa-menubar-mobile-sidebar");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("name", ctx_r1.usuario ? ctx_r1.usuario.nome : "MAPA");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.usuario ? ctx_r1.usuario.nome : ɵngcc0.ɵɵpipeBind1(8, 11, "CORE.HEADER.NOT_AUTHENTICATED"));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.languages.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("model", ctx_r1.nav)("styleClass", "mapa-menubar-mobile-nav");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("model", ctx_r1.navRight)("styleClass", "mapa-menubar-mobile-nav");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.appName);
} }
function AdminLayoutComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "mapa-header");
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelement(3, "router-outlet");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function BlankLayoutComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "router-outlet");
    ɵngcc0.ɵɵelementEnd();
} }
const reference = {
    config: {
        contexto: '',
        wso2Url: '',
        debug: false
    }
};
/** @type {?} */
let callbacks = [];
/** @type {?} */
let resolved = false;
/**
 * Serviço estático para gerenciar a configuração da aplicação por ambiente de execução
 */
class MapaEnviromentService {
    /**
     * Define a configuração do ambiente. Deve ser invocado apenas uma única vez no fluxo de vida da aplicação. A chamada desse método é
     * feita pelo componennte MAPA CORE, durante a inicialização do APP
     * @param {?} newConfig
     * @return {?}
     */
    static set(newConfig) {
        if (resolved) {
            throw new Error('MapaEnviromentService estado inválido. Não é permitido a execução deste método mais de uma vez.');
        }
        /** @type {?} */
        let attr;
        for (attr in newConfig) {
            if (!newConfig.hasOwnProperty(attr)) {
                continue;
            }
            reference.config[attr] = newConfig[attr];
        }
        resolved = true;
        callbacks.forEach((/**
         * @param {?} callback
         * @return {?}
         */
        callback => {
            callback(reference.config);
        }));
        // Limpa as referencias
        callbacks = [];
    }
    /**
     * Obtém a configuração atual.
     *
     * ATENÇÃO: O retorno desse método não garante o carregamento da configuração do ambiente. Use o "callback" para aguardar o
     * carregamento do environment.json antes de executar alguma ação de forma segura
     *
     * @param {?=} callback Permite esperar pela definição da configuração do ambiente antes de executar o callback
     * @return {?}
     */
    static get(callback) {
        if (callback) {
            if (resolved) {
                callback(reference.config);
            }
            else {
                callbacks.push(callback);
            }
        }
        return reference.config;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/util/WSO2.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe para instanciação de clientes de acesso ao WSO2
 */
class WSO2Client {
    /**
     * @param {?} api
     * @param {?} version
     * @param {?} http
     * @param {?=} accessToken
     */
    constructor(api, version, http, accessToken) {
        this.api = api;
        this.version = version;
        this.http = http;
        this.accessToken = accessToken;
        MapaEnviromentService.get((/**
         * @param {?} env
         * @return {?}
         */
        (env) => {
            this.wso2Url = env.wso2Url;
        }));
    }
    /**
     * @param {?} endpoint
     * @return {?}
     */
    getUrl(endpoint) {
        /** @type {?} */
        let url = `${this.wso2Url}${this.api}/${this.version}${endpoint}`;
        /** @type {?} */
        const config = MapaEnviromentService.get();
        if (config.localUrl && this.api !== 'MapaAuthorization' && config.ambiente.toLowerCase() === 'local') {
            url = `${config.localUrl}${endpoint}`;
        }
        return url;
    }
    /**
     * @return {?}
     */
    getHttpClient() {
        return this.http;
    }
    /**
     * Executa uma chamada GET na API
     * @template T
     * @param {?} endpoint
     * @param {?=} params
     * @return {?}
     */
    get(endpoint, params) {
        /** @type {?} */
        const url = this.getUrl(endpoint);
        /** @type {?} */
        const httpOptions = {
            headers: this.getHeaders(),
            params: params
        };
        return this.http.get(url, httpOptions);
    }
    /**
     * Executa uma chamada POST na API
     * @template T
     * @param {?} endpoint
     * @param {?} body
     * @param {?=} params
     * @return {?}
     */
    post(endpoint, body, params) {
        /** @type {?} */
        const url = this.getUrl(endpoint);
        /** @type {?} */
        const httpOptions = {
            headers: this.getHeaders(),
            params: params
        };
        return this.http.post(url, body, httpOptions);
    }
    /**
     * Executa uma chamada PUT na API
     * @template T
     * @param {?} endpoint
     * @param {?} body
     * @param {?=} params
     * @return {?}
     */
    put(endpoint, body, params) {
        /** @type {?} */
        const url = this.getUrl(endpoint);
        /** @type {?} */
        const httpOptions = {
            headers: this.getHeaders(),
            params: params
        };
        return this.http.put(url, body, httpOptions);
    }
    /**
     * Executa uma chamada DELETE na API
     * @template T
     * @param {?} endpoint
     * @param {?=} params
     * @return {?}
     */
    delete(endpoint, params) {
        /** @type {?} */
        const url = this.getUrl(endpoint);
        /** @type {?} */
        const httpOptions = {
            headers: this.getHeaders(),
            params: params
        };
        return this.http.delete(url, httpOptions);
    }
    /**
     * Obtém o Cabeçalho padrão
     * @private
     * @return {?}
     */
    getHeaders() {
        /** @type {?} */
        const headers = new HttpHeaders({ 'Accept': 'application/json' });
        // Quando a API é publica, não existe o token
        if (this.accessToken) {
            headers.append('Authorization', 'Bearer ' + this.accessToken);
        }
        return headers;
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    WSO2Client.prototype.wso2Url;
    /**
     * @type {?}
     * @private
     */
    WSO2Client.prototype.api;
    /**
     * @type {?}
     * @private
     */
    WSO2Client.prototype.version;
    /**
     * @type {?}
     * @private
     */
    WSO2Client.prototype.http;
    /**
     * @type {?}
     * @private
     */
    WSO2Client.prototype.accessToken;
}
/**
 * Componente genérico para criação de clientes WSO2
 */
class WSO2 {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * Obtém a instancia de um Client Wso2
     * @param {?} api
     * @param {?} version
     * @param {?=} accessToken
     * @return {?}
     */
    getClient(api, version, accessToken) {
        return new WSO2Client(api, version, this.http, accessToken);
    }
}
WSO2.ɵfac = function WSO2_Factory(t) { return new (t || WSO2)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
/** @nocollapse */
WSO2.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ WSO2.ɵprov = ɵɵdefineInjectable({ factory: function WSO2_Factory() { return new WSO2(ɵɵinject(HttpClient)); }, token: WSO2, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WSO2, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    WSO2.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/util/wso2/aplicacao.api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Informações sobre a aplicação atual
 * @record
 */
function Aplicacao() { }
if (false) {
    /** @type {?} */
    Aplicacao.prototype.id;
    /** @type {?} */
    Aplicacao.prototype.nome;
    /** @type {?} */
    Aplicacao.prototype.versao;
    /** @type {?} */
    Aplicacao.prototype.sigla;
    /** @type {?} */
    Aplicacao.prototype.objetivo;
    /** @type {?} */
    Aplicacao.prototype.usuarioExterno;
    /** @type {?} */
    Aplicacao.prototype.usuarioEstrangeiro;
}
/**
 * Tipagem do resultado da requisição sobre detalhes da aplcação no WSO2
 * @record
 */
function AplicacaoAPIResponse() { }
if (false) {
    /** @type {?} */
    AplicacaoAPIResponse.prototype.ST_USUARIO_EXTERNO;
    /** @type {?} */
    AplicacaoAPIResponse.prototype.ID_APLICACAO;
    /** @type {?} */
    AplicacaoAPIResponse.prototype.SG_APLICACAO;
    /** @type {?} */
    AplicacaoAPIResponse.prototype.NM_APLICACAO;
    /** @type {?} */
    AplicacaoAPIResponse.prototype.DS_OBJETIVO;
    /** @type {?} */
    AplicacaoAPIResponse.prototype.DS_VERSAO;
    /** @type {?} */
    AplicacaoAPIResponse.prototype.ST_USUARIO_ESTRANGEIRO;
}
/**
 * Api de integração com o WSO2 para obter os dados da aplicação atual
 */
class AplicacaoAPI {
    /**
     * @param {?} wso2
     */
    constructor(wso2) {
        this.wso2 = wso2;
        this.wso2Client = wso2.getClient('MapaAuthorization', '1.0.0');
    }
    /**
     * Obtém os detalhes da aplicação atual
     * @return {?}
     */
    obterAplicacao() {
        if (!this.promise_obterAplicacao) {
            this.promise_obterAplicacao = new Promise((/**
             * @param {?} accept
             * @param {?} reject
             * @return {?}
             */
            (accept, reject) => {
                if (this.aplicacao) {
                    this.promise_obterAplicacao = null;
                    return accept(this.aplicacao);
                }
                MapaEnviromentService.get((/**
                 * @param {?} config
                 * @return {?}
                 */
                (config) => {
                    if (config.mock && config.mock.aplicacao) {
                        this.aplicacao = this.extrairApplicacao(config.mock.aplicacao);
                        this.promise_obterAplicacao = null;
                        accept(this.aplicacao);
                    }
                    else {
                        return this.wso2Client
                            .get(`/ConsultaAplicacao/${config.contexto}`).toPromise()
                            .then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        (data) => {
                            this.aplicacao = this.extrairApplicacao(data.aplicacao);
                            this.promise_obterAplicacao = null;
                            accept(this.aplicacao);
                        }))
                            .catch((/**
                         * @param {?} reason
                         * @return {?}
                         */
                        reason => {
                            this.promise_obterAplicacao = null;
                            reject(reason);
                        }));
                    }
                }));
            }));
        }
        return this.promise_obterAplicacao;
    }
    /**
     * Obtém a aplicação, apenas se esta for pública
     * @return {?}
     */
    obterAplicacaoSePublica() {
        if (!this.promise_obterAplicacaoSePublica) {
            this.promise_obterAplicacaoSePublica = new Promise((/**
             * @param {?} accept
             * @param {?} reject
             * @return {?}
             */
            (accept, reject) => {
                if (this.aplicacaoPublica === true) {
                    return this.obterAplicacao()
                        .then((/**
                     * @param {?} app
                     * @return {?}
                     */
                    (app) => {
                        this.promise_obterAplicacaoSePublica = null;
                        accept(app);
                    }))
                        .catch((/**
                     * @param {?} reason
                     * @return {?}
                     */
                    reason => {
                        this.promise_obterAplicacaoSePublica = null;
                        reject(reason);
                    }));
                }
                else if (this.aplicacaoPublica === false) {
                    return accept(null);
                }
                MapaEnviromentService.get((/**
                 * @param {?} config
                 * @return {?}
                 */
                (config) => {
                    if (config.mock && config.mock.aplicacao) {
                        this.aplicacaoPublica = true;
                        this.obterAplicacao()
                            .then((/**
                         * @param {?} app
                         * @return {?}
                         */
                        (app) => {
                            this.promise_obterAplicacaoSePublica = null;
                            accept(app);
                        }))
                            .catch((/**
                         * @param {?} reason
                         * @return {?}
                         */
                        reason => {
                            this.promise_obterAplicacaoSePublica = null;
                            reject(reason);
                        }));
                    }
                    else {
                        this.obterAplicacao()
                            .then((/**
                         * @param {?} app
                         * @return {?}
                         */
                        (app) => {
                            this.wso2Client
                                .get('/APPPublicas').toPromise()
                                .then((/**
                             * @param {?} data
                             * @return {?}
                             */
                            (data) => {
                                this.promise_obterAplicacaoSePublica = null;
                                /** @type {?} */
                                const publica = data.apps.app.find((/**
                                 * @param {?} value
                                 * @return {?}
                                 */
                                value => {
                                    return this.extrairApplicacao(value).id === app.id;
                                }));
                                if (publica) {
                                    this.aplicacaoPublica = true;
                                    accept(app);
                                }
                                else {
                                    this.aplicacaoPublica = false;
                                    accept(null);
                                }
                            }))
                                .catch((/**
                             * @param {?} reason
                             * @return {?}
                             */
                            reason => {
                                this.promise_obterAplicacaoSePublica = null;
                                reject(reason);
                            }));
                        }))
                            .catch((/**
                         * @param {?} reason
                         * @return {?}
                         */
                        reason => {
                            this.promise_obterAplicacaoSePublica = null;
                            reject(reason);
                        }));
                    }
                }));
            }));
        }
        return this.promise_obterAplicacaoSePublica;
    }
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    extrairApplicacao(response) {
        return {
            id: Number.parseInt(response.ID_APLICACAO, 10),
            nome: response.NM_APLICACAO,
            versao: response.DS_VERSAO,
            sigla: response.SG_APLICACAO,
            objetivo: response.DS_OBJETIVO,
            usuarioExterno: response.ST_USUARIO_EXTERNO === 'S',
            usuarioEstrangeiro: response.ST_USUARIO_ESTRANGEIRO === 'S'
        };
    }
}
AplicacaoAPI.ɵfac = function AplicacaoAPI_Factory(t) { return new (t || AplicacaoAPI)(ɵngcc0.ɵɵinject(WSO2)); };
/** @nocollapse */
AplicacaoAPI.ctorParameters = () => [
    { type: WSO2 }
];
/** @nocollapse */ AplicacaoAPI.ɵprov = ɵɵdefineInjectable({ factory: function AplicacaoAPI_Factory() { return new AplicacaoAPI(ɵɵinject(WSO2)); }, token: AplicacaoAPI, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AplicacaoAPI, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: WSO2 }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AplicacaoAPI.prototype.aplicacao;
    /**
     * @type {?}
     * @private
     */
    AplicacaoAPI.prototype.wso2Client;
    /**
     * @type {?}
     * @private
     */
    AplicacaoAPI.prototype.aplicacaoPublica;
    /**
     * @type {?}
     * @private
     */
    AplicacaoAPI.prototype.promise_obterAplicacao;
    /**
     * @type {?}
     * @private
     */
    AplicacaoAPI.prototype.promise_obterAplicacaoSePublica;
    /**
     * @type {?}
     * @private
     */
    AplicacaoAPI.prototype.wso2;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/util/wso2/modulos.api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const TIPO_MODULO = {
    DOMINIO: "DO",
    ITEM_DE_MENU: "IM",
    SERVICO: "SV",
    WEB_SERVICE: "WS",
    WEB_SERVICE_DELETE: "WS_DELETE",
    WEB_SERVICE_GET: "WS_GET",
    WEB_SERVICE_POST: "WS_POST",
    WEB_SERVICE_PUT: "WS_PUT",
};
/**
 * @record
 */
function Modulo() { }
if (false) {
    /** @type {?} */
    Modulo.prototype.id;
    /** @type {?|undefined} */
    Modulo.prototype.pai;
    /** @type {?} */
    Modulo.prototype.ordem;
    /** @type {?} */
    Modulo.prototype.nome;
    /** @type {?} */
    Modulo.prototype.tipo;
    /** @type {?} */
    Modulo.prototype.acao;
    /** @type {?} */
    Modulo.prototype.publico;
}
/**
 * @record
 */
function ModuloAPIResponse() { }
if (false) {
    /** @type {?} */
    ModuloAPIResponse.prototype.ID_MODULO;
    /** @type {?} */
    ModuloAPIResponse.prototype.ID_MODULO_PAI;
    /** @type {?} */
    ModuloAPIResponse.prototype.NR_ORDEM_MODULO;
    /** @type {?} */
    ModuloAPIResponse.prototype.NM_MODULO;
    /** @type {?} */
    ModuloAPIResponse.prototype.NM_ACAO;
    /** @type {?} */
    ModuloAPIResponse.prototype.CS_MODULO;
    /** @type {?} */
    ModuloAPIResponse.prototype.ST_PUBLICO;
    /** @type {?} */
    ModuloAPIResponse.prototype.ST_SAIDA_WS;
}
/**
 * @record
 */
function ModuloGrupoAPIResponse() { }
if (false) {
    /** @type {?} */
    ModuloGrupoAPIResponse.prototype.ID_MODULO;
    /** @type {?} */
    ModuloGrupoAPIResponse.prototype.ID_GRUPO;
}
/**
 * @record
 */
function GrupoModulos() { }
/**
 * Api de integração com o WSO2 para obter os dados da aplicação atual
 */
class ModulosAPI {
    /**
     * @param {?} wso2
     */
    constructor(wso2) {
        this.wso2 = wso2;
        this.wso2Client = wso2.getClient('MapaAuthorization', '1.0.0');
    }
    /**
     * Obtém todos os módulos habilitados para o grupo informado, apenas para a aplicação atual
     * @param {?} idGrupo
     * @return {?}
     */
    obterModulosGrupo(idGrupo) {
        return this.obterGrupoXrefModulos()
            .then((/**
         * @param {?} grupoXModulos
         * @return {?}
         */
        grupoXModulos => {
            if (grupoXModulos.hasOwnProperty(idGrupo)) {
                return grupoXModulos[idGrupo];
            }
            return [];
        }));
    }
    /**
     * Obtém todos os módulos Públicos da aplicação atual
     * @return {?}
     */
    obterModulosPublicos() {
        return this.obterModulosAplicacao().then((/**
         * @param {?} modulos
         * @return {?}
         */
        modulos => {
            /** @type {?} */
            const out = modulos.filter((/**
             * @param {?} modulo
             * @return {?}
             */
            modulo => modulo.publico));
            // Se possuir algum modulo publico. Torna o modo principal como publico tambéms
            if (out.length > 0) {
                /** @type {?} */
                const mod = modulos.find((/**
                 * @param {?} modulo
                 * @return {?}
                 */
                modulo => {
                    return !modulo.pai || modulo.pai === 0;
                }));
                if (out.indexOf(mod) < 0) {
                    out.push(mod);
                }
            }
            return out;
        }));
    }
    /**
     * @return {?}
     */
    obterModulosAplicacao() {
        if (!this.promise_obterModulosAplicacao) {
            this.promise_obterModulosAplicacao = new Promise((/**
             * @param {?} accept
             * @param {?} reject
             * @return {?}
             */
            (accept, reject) => {
                if (this.modulos) {
                    this.promise_obterModulosAplicacao = null;
                    return accept(this.modulos);
                }
                MapaEnviromentService.get((/**
                 * @param {?} config
                 * @return {?}
                 */
                (config) => {
                    if (config.mock && config.mock.modulos) {
                        this.modulos = config.mock.modulos
                            .map(this.extrairModulo)
                            // Apenas módulos de Frontend (DOMINIO, ITEM_DE_MENU e SERVICO)
                            .filter((/**
                         * @param {?} modulo
                         * @return {?}
                         */
                        modulo => {
                            return [TIPO_MODULO.DOMINIO, TIPO_MODULO.ITEM_DE_MENU, TIPO_MODULO.SERVICO].includes(modulo.tipo);
                        }));
                        this.promise_obterModulosAplicacao = null;
                        accept(this.modulos);
                    }
                    else {
                        /*
                         * Obtém os dados da API do WSO2
                         *
                         * {
                         *    "modulos": {
                         *      "modulo": [
                         *        {
                         *          "ID_MODULO": "43894",
                         *          "ID_MODULO_PAI": "43812",
                         *          "NM_MODULO": "Demandante",
                         *          "NM_ACAO": "#",
                         *          "CS_MODULO": "WS",
                         *          "ST_PUBLICO": "N",
                         *          "ST_SAIDA_WS": "N",
                         *          "NR_ORDEM_MODULO": "2",
                         *        },
                         *      ]
                         *    }
                         *  }
                         */
                        return this.wso2Client
                            .get(`/ConsultaModulosAplicacao/${config.contexto}`).toPromise()
                            .then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        (data) => {
                            if (data.modulos && data.modulos.modulo) {
                                this.modulos = data.modulos.modulo
                                    .map(this.extrairModulo)
                                    // Apenas módulos de Frontend (DOMINIO, ITEM_DE_MENU e SERVICO)
                                    .filter((/**
                                 * @param {?} modulo
                                 * @return {?}
                                 */
                                modulo => {
                                    return [TIPO_MODULO.DOMINIO, TIPO_MODULO.ITEM_DE_MENU, TIPO_MODULO.SERVICO].includes(modulo.tipo);
                                }));
                            }
                            else {
                                this.modulos = [];
                            }
                            this.promise_obterModulosAplicacao = null;
                            accept(this.modulos);
                        }))
                            .catch((/**
                         * @param {?} reason
                         * @return {?}
                         */
                        reason => {
                            this.promise_obterModulosAplicacao = null;
                            reject(reason);
                        }));
                    }
                }));
            }));
        }
        return this.promise_obterModulosAplicacao;
    }
    /**
     * Obtém o mapeamento cruzado entren ID_GRUPO -> [MODULO]
     * @return {?}
     */
    obterGrupoXrefModulos() {
        if (!this.promise_obterGrupoXrefModulos) {
            this.promise_obterGrupoXrefModulos = new Promise((/**
             * @param {?} accept
             * @param {?} reject
             * @return {?}
             */
            (accept, reject) => {
                if (this.gruposModulos) {
                    this.promise_obterGrupoXrefModulos = null;
                    return accept(this.gruposModulos);
                }
                MapaEnviromentService.get((/**
                 * @param {?} config
                 * @return {?}
                 */
                (config) => {
                    this.obterModulosAplicacao()
                        .then((/**
                     * @return {?}
                     */
                    () => {
                        if (config.mock && config.mock.modulos_grupos) {
                            return this.extrairModulosGrupos(config.mock.modulos_grupos)
                                .then((/**
                             * @param {?} gruposModulos
                             * @return {?}
                             */
                            gruposModulos => {
                                this.gruposModulos = gruposModulos;
                                this.promise_obterGrupoXrefModulos = null;
                                accept(this.gruposModulos);
                            }));
                        }
                        else {
                            /*
                             * {
                             *    "modulos_grupos": {
                             *      "modulo_grupo": [
                             *        {
                             *          "NM_MODULO": "HUB",
                             *          "ID_MODULO": "43812",
                             *          "ID_GRUPO": "15813"
                             *        },
                             *      ]
                             *    }
                             *  }
                             */
                            return this.wso2Client
                                .get(`/ConsultaGruposModulos/${config.contexto}`).toPromise()
                                .then((/**
                             * @param {?} data
                             * @return {?}
                             */
                            (data) => {
                                if (data.modulos_grupos && data.modulos_grupos.modulo_grupo) {
                                    return this.extrairModulosGrupos(data.modulos_grupos.modulo_grupo)
                                        .then((/**
                                     * @param {?} gruposModulos
                                     * @return {?}
                                     */
                                    gruposModulos => {
                                        this.gruposModulos = gruposModulos;
                                        this.promise_obterGrupoXrefModulos = null;
                                        accept(this.gruposModulos);
                                    }));
                                }
                                else {
                                    this.promise_obterGrupoXrefModulos = null;
                                    this.gruposModulos = {};
                                    accept(this.gruposModulos);
                                }
                            }));
                        }
                    }))
                        .catch((/**
                     * @param {?} reason
                     * @return {?}
                     */
                    reason => {
                        this.promise_obterGrupoXrefModulos = null;
                        reject(reason);
                    }));
                }));
            }));
        }
        return this.promise_obterGrupoXrefModulos;
    }
    /**
     * @private
     * @param {?} registros
     * @return {?}
     */
    extrairModulosGrupos(registros) {
        return this.obterModulosAplicacao()
            .then((/**
         * @param {?} modulosAplicacao
         * @return {?}
         */
        modulosAplicacao => {
            /** @type {?} */
            const out = {};
            registros.forEach((/**
             * @param {?} registro
             * @return {?}
             */
            registro => {
                /** @type {?} */
                const idGrupo = Number.parseInt(registro.ID_GRUPO, 10);
                /** @type {?} */
                const idModulo = Number.parseInt(registro.ID_MODULO, 10);
                if (!out[idGrupo]) {
                    out[idGrupo] = [];
                }
                /** @type {?} */
                const modulo = modulosAplicacao.find((/**
                 * @param {?} it
                 * @return {?}
                 */
                it => it.id === idModulo));
                if (modulo && !out[idGrupo].find((/**
                 * @param {?} it
                 * @return {?}
                 */
                it => it.id === idModulo))) {
                    out[idGrupo].push(modulo);
                }
            }));
            return out;
        }));
    }
    /**
     * @private
     * @param {?} dados
     * @return {?}
     */
    extrairModulo(dados) {
        /** @type {?} */
        const role = {
            id: Number.parseInt(dados.ID_MODULO, 10),
            pai: dados.ID_MODULO_PAI ? Number.parseInt(dados.ID_MODULO_PAI, 10) : undefined,
            ordem: Number.parseInt(dados.NR_ORDEM_MODULO, 10),
            nome: dados.NM_MODULO,
            acao: dados.NM_ACAO,
            publico: dados.ST_PUBLICO === 'S',
            tipo: dados.CS_MODULO
        };
        /** @type {?} */
        let name = role.nome;
        if (role.acao && role.acao !== '') {
            name = role.acao;
        }
        return role;
    }
}
ModulosAPI.ɵfac = function ModulosAPI_Factory(t) { return new (t || ModulosAPI)(ɵngcc0.ɵɵinject(WSO2)); };
/** @nocollapse */
ModulosAPI.ctorParameters = () => [
    { type: WSO2 }
];
/** @nocollapse */ ModulosAPI.ɵprov = ɵɵdefineInjectable({ factory: function ModulosAPI_Factory() { return new ModulosAPI(ɵɵinject(WSO2)); }, token: ModulosAPI, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ModulosAPI, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: WSO2 }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ModulosAPI.prototype.wso2Client;
    /**
     * @type {?}
     * @private
     */
    ModulosAPI.prototype.modulos;
    /**
     * @type {?}
     * @private
     */
    ModulosAPI.prototype.gruposModulos;
    /**
     * @type {?}
     * @private
     */
    ModulosAPI.prototype.promise_obterGrupoXrefModulos;
    /**
     * @type {?}
     * @private
     */
    ModulosAPI.prototype.promise_obterModulosAplicacao;
    /**
     * @type {?}
     * @private
     */
    ModulosAPI.prototype.wso2;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/model/services.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * <pre>
 * {
 *   "aud": "samuel.guimaraes",
 *   "sub": "samuel.guimaraes",
 *   "Nome": "samuel.guimaraes",
 *   "idPessoa": "55592938",
 *   "nome": "Samuel Correia Guimaraes",
 *   "email": "samuel.guimaraes\@contratado.agricultura.gov.br",
 *   "documento": "03556240106",
 *   "idUsuario": "337158",
 *   "Aplicacoes": "890;871;1",
 *   "Grupos": "2475;2417;20",
 *   "ativo": "A",
 *   "VALIDO": "2021-06-11T15:23:45.300-03:00",
 *   "ACCESS_TOKEN": "8fe35607-87d4-3a93-ba7a-7b296b8c71c6",
 *   "REFRESH_TOKEN": "26a53ddb-a999-3167-b41f-ab3d245140d7",
 *   "BASIC": "cTRmM3V2OWsyYTUzaTh1ZjM5ajZsMW41OXI1OTo1cHYxcGJzMjM5a3UybHZhOWR1MDRreWVxcW8w",
 *   "CONSUMER_KEY": "q4f3uv9k2a53i8uf39j6l1n59r59",
 *   "CONSUMER_SECRET": "5pv1pbs239ku2lva9du04kyeqqo0"
 * }
 * </pre>
 * @record
 */
function MapaJWT() { }
if (false) {
    /** @type {?|undefined} */
    MapaJWT.prototype.Nome;
    /** @type {?|undefined} */
    MapaJWT.prototype.idPessoa;
    /** @type {?|undefined} */
    MapaJWT.prototype.nome;
    /** @type {?|undefined} */
    MapaJWT.prototype.email;
    /** @type {?|undefined} */
    MapaJWT.prototype.documento;
    /** @type {?|undefined} */
    MapaJWT.prototype.idUsuario;
    /** @type {?|undefined} */
    MapaJWT.prototype.Aplicacoes;
    /** @type {?|undefined} */
    MapaJWT.prototype.Grupos;
    /** @type {?|undefined} */
    MapaJWT.prototype.ativo;
    /** @type {?|undefined} */
    MapaJWT.prototype.VALIDO;
    /** @type {?|undefined} */
    MapaJWT.prototype.ACCESS_TOKEN;
    /** @type {?|undefined} */
    MapaJWT.prototype.REFRESH_TOKEN;
    /** @type {?|undefined} */
    MapaJWT.prototype.BASIC;
    /** @type {?|undefined} */
    MapaJWT.prototype.CONSUMER_KEY;
    /** @type {?|undefined} */
    MapaJWT.prototype.CONSUMER_SECRET;
}
class Usuario {
    /**
     * @param {?} perfil
     * @return {?}
     */
    hasPerfil(perfil) {
        return this.perfis.findIndex((/**
         * @param {?} value
         * @return {?}
         */
        value => value === perfil)) !== -1;
    }
    /**
     * @param {?} perfis
     * @return {?}
     */
    hasAnyPerfil(perfis) {
        for (let i = 0; i < perfis.length; i++) {
            if (this.hasPerfil(perfis[i])) {
                return true;
            }
        }
        return false;
    }
}
if (false) {
    /** @type {?} */
    Usuario.prototype.username;
    /** @type {?} */
    Usuario.prototype.idPessoa;
    /** @type {?} */
    Usuario.prototype.nome;
    /** @type {?} */
    Usuario.prototype.email;
    /** @type {?} */
    Usuario.prototype.documento;
    /** @type {?} */
    Usuario.prototype.idUsuario;
    /** @type {?} */
    Usuario.prototype.perfis;
    /** @type {?} */
    Usuario.prototype.ativo;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/util/wso2/grupos.api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Grupo de acesso declarado no SEGADMIN
 * @record
 */
function Grupo() { }
if (false) {
    /** @type {?} */
    Grupo.prototype.id;
    /** @type {?|undefined} */
    Grupo.prototype.pai;
    /** @type {?} */
    Grupo.prototype.nome;
    /** @type {?} */
    Grupo.prototype.acessoEstrangeiro;
    /** @type {?} */
    Grupo.prototype.acessoExterno;
}
/**
 * Dado da resposta do serviço de listagem de grupos da aplicação
 * @record
 */
function GrupoAPIResponse() { }
if (false) {
    /** @type {?} */
    GrupoAPIResponse.prototype.ID_GRUPO;
    /** @type {?} */
    GrupoAPIResponse.prototype.ID_GRUPO_PAI;
    /** @type {?} */
    GrupoAPIResponse.prototype.NM_GRUPO;
    /** @type {?} */
    GrupoAPIResponse.prototype.ST_ACESSO_ESTRANGEIRO;
    /** @type {?} */
    GrupoAPIResponse.prototype.ST_ACESSO_EXTERNO;
}
/**
 * Api de integração com o WSO2 para obter os grupos da aplicação atual
 */
class GruposAPI {
    /**
     * @param {?} wso2
     */
    constructor(wso2) {
        this.wso2 = wso2;
        // this.grupos = [];
        this.wso2Client = wso2.getClient('MapaAuthorization', '1.0.0');
    }
    /**
     * Obtém todos os grupos da aplicação atual
     * @return {?}
     */
    obterGruposAplicacao() {
        if (!this.promise_obterGruposAplicacao) {
            this.promise_obterGruposAplicacao = new Promise((/**
             * @param {?} accept
             * @param {?} reject
             * @return {?}
             */
            (accept, reject) => {
                if (this.grupos) {
                    this.promise_obterGruposAplicacao = null;
                    return accept(this.grupos);
                }
                MapaEnviromentService.get((/**
                 * @param {?} config
                 * @return {?}
                 */
                (config) => {
                    if (config.mock && config.mock.grupos) {
                        this.grupos = config.mock.grupos.map(this.extrairGrupo);
                        this.promise_obterGruposAplicacao = null;
                        accept(this.grupos);
                    }
                    else {
                        /*
                         * Obtém os dados da API do WSO2
                         *
                         * {
                         *    "grupos": {
                         *      "grupo": [
                         *        {
                         *          "ID_GRUPO": "15813",
                         *          "ID_GRUPO_PAI": null,
                         *          "NM_GRUPO": "Administrador"
                         *          "ST_ACESSO_ESTRANGEIRO": "N",
                         *          "ST_ACESSO_EXTERNO": "N",
                         *        },
                         *        {
                         *          "ID_GRUPO": "15814",
                         *          "ID_GRUPO_PAI": null,
                         *          "ST_ACESSO_ESTRANGEIRO": "N",
                         *          "ST_ACESSO_EXTERNO": "N",
                         *          "NM_GRUPO": "Gestor"
                         *        }
                         *      ]
                         *    }
                         *  }
                         */
                        return this.wso2Client
                            .get(`/ConsultaGruposAplicacao/${config.contexto}`).toPromise()
                            .then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        (data) => {
                            if (data.grupos && data.grupos.grupo) {
                                this.grupos = data.grupos.grupo.map(this.extrairGrupo);
                            }
                            else {
                                this.grupos = [];
                            }
                            this.promise_obterGruposAplicacao = null;
                            accept(this.grupos);
                        }))
                            .catch((/**
                         * @param {?} reason
                         * @return {?}
                         */
                        reason => {
                            this.promise_obterGruposAplicacao = null;
                            reject(reason);
                        }));
                    }
                }));
            }));
        }
        return this.promise_obterGruposAplicacao;
    }
    /**
     * Obtém os detalhes de um Grupo por id.
     * <p>
     * Só faz a consulta nos Grupos da aplicação atual
     * @param {?} idGrupo
     * @return {?}
     */
    obterGrupoPorId(idGrupo) {
        return this.obterGruposAplicacao()
            .then((/**
         * @param {?} grupos
         * @return {?}
         */
        (grupos) => {
            return grupos.find((/**
             * @param {?} grupo
             * @return {?}
             */
            grupo => grupo.id === idGrupo));
        }));
    }
    /**
     * @private
     * @param {?} dados
     * @return {?}
     */
    extrairGrupo(dados) {
        return {
            id: Number.parseInt(dados.ID_GRUPO, 10),
            pai: dados.ID_GRUPO_PAI
                ? Number.parseInt(dados.ID_GRUPO_PAI, 10)
                : undefined,
            nome: dados.NM_GRUPO,
            acessoEstrangeiro: dados.ST_ACESSO_ESTRANGEIRO === 'S',
            acessoExterno: dados.ST_ACESSO_EXTERNO === 'S'
        };
    }
}
GruposAPI.ɵfac = function GruposAPI_Factory(t) { return new (t || GruposAPI)(ɵngcc0.ɵɵinject(WSO2)); };
/** @nocollapse */
GruposAPI.ctorParameters = () => [
    { type: WSO2 }
];
/** @nocollapse */ GruposAPI.ɵprov = ɵɵdefineInjectable({ factory: function GruposAPI_Factory() { return new GruposAPI(ɵɵinject(WSO2)); }, token: GruposAPI, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GruposAPI, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: WSO2 }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    GruposAPI.prototype.wso2Client;
    /**
     * @type {?}
     * @private
     */
    GruposAPI.prototype.grupos;
    /**
     * @type {?}
     * @private
     */
    GruposAPI.prototype.promise_obterGruposAplicacao;
    /**
     * @type {?}
     * @private
     */
    GruposAPI.prototype.wso2;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/wso2Integration.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Wso2IntegrationService {
    /**
     * @param {?} oauthService
     * @param {?} wso2
     * @param {?} aplicacaoAPI
     * @param {?} gruposAPI
     * @param {?} modulosAPI
     * @param {?} router
     */
    constructor(oauthService, wso2, aplicacaoAPI, gruposAPI, modulosAPI, router) {
        this.oauthService = oauthService;
        this.wso2 = wso2;
        this.aplicacaoAPI = aplicacaoAPI;
        this.gruposAPI = gruposAPI;
        this.modulosAPI = modulosAPI;
        this.router = router;
        this.STORAGE = localStorage;
        this.runningLoadSuject = false;
        this.MAPA_MOCK_STORAGE_KEY = 'MAPA_MOCK_ACCESS_TOKEN';
        this.aplicacao = new BehaviorSubject(null);
        this.modulos = new BehaviorSubject([]);
        this.usuario = new BehaviorSubject(null);
        /** @type {?} */
        const contexto = MapaEnviromentService.get().contexto.replace('_api', '');
        this.wso2Client = this.wso2.getClient(contexto, '1.0.0', null);
        this.configureOauthImplicitFlowAuthentication();
        setTimeout((/**
         * @return {?}
         */
        () => this.loadSubject()), 250);
        // Configuração para evitar erro de rotas quando a url for "#access_token=ehd..."
        this.router.events.pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            return (event.toString()).startsWith('NavigationStart');
        })), filter((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            return (/access_token|id_token|error/).test(((/** @type {?} */ (event))).url);
        }))).subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            console.log('Wso2IntegrationService :: Iniciando processo de autenticação...', event);
            this.oauthService.tryLogin()
                .then((/**
             * @param {?} value
             * @return {?}
             */
            value => {
                console.log('Wso2IntegrationService :: tryLogin() = ' + value);
                this.loadSubject().catch((/**
                 * @param {?} reason
                 * @return {?}
                 */
                reason => {
                    console.error('Wso2IntegrationService :: tryLogin() -> loadSubject()', reason);
                }));
            }))
                .catch((/**
             * @param {?} reason
             * @return {?}
             */
            reason => console.error('Wso2IntegrationService :: tryLogin()', reason)));
            this.router.navigateByUrl('/')
                .then((/**
             * @param {?} value
             * @return {?}
             */
            value => console.log(value)));
        }));
    }
    /**
     * @private
     * @return {?}
     */
    static userIsMocked() {
        return !!MapaEnviromentService.get().mock && !!MapaEnviromentService.get().mock.jwt;
    }
    /**
     * O WSO2 entrega a string "null" quando o campo é vazio
     * @private
     * @param {?} value
     * @return {?}
     */
    static ignoreNullString(value) {
        if (value === '' || value === 'null') {
            return null;
        }
        return value;
    }
    /**
     * @return {?}
     */
    getJWT() {
        /** @type {?} */
        const token = this.getTokenJWT();
        return !!token ? this.decodeToken(token) : null;
    }
    /**
     * @param {?} token
     * @return {?}
     */
    decodeToken(token) {
        return JSON.parse(atob(token.split('.')[1]));
    }
    /**
     * Obtém o token JWT proveniente do Oauth2 ou o valor MOCK (se existir)
     * @return {?}
     */
    getTokenJWT() {
        if (Wso2IntegrationService.userIsMocked()) {
            return this.STORAGE.getItem(this.MAPA_MOCK_STORAGE_KEY);
        }
        return this.oauthService.getAccessToken();
    }
    /**
     * @private
     * @return {?}
     */
    sanitizeTokenJWT() {
        /** @type {?} */
        const jwt = this.getJWT();
        if (!jwt) {
            return null;
        }
        /** @type {?} */
        const sanitizedJWT = {
            Nome: jwt.Nome,
            idPessoa: jwt.idPessoa,
            nome: jwt.nome,
            email: jwt.email,
            documento: jwt.documento,
            idUsuario: jwt.idUsuario,
            Aplicacoes: jwt.Aplicacoes,
            Grupos: jwt.Grupos,
            ativo: jwt.ativo,
            VALIDO: jwt.VALIDO,
            ACCESS_TOKEN: jwt.ACCESS_TOKEN,
            REFRESH_TOKEN: jwt.REFRESH_TOKEN,
            BASIC: jwt.BASIC,
            CONSUMER_KEY: jwt.CONSUMER_KEY,
            CONSUMER_SECRET: jwt.CONSUMER_SECRET,
        };
        /** @type {?} */
        const sanitizedToken = this.prepareJWT(sanitizedJWT);
        if (Wso2IntegrationService.userIsMocked()) {
            this.STORAGE.setItem(this.MAPA_MOCK_STORAGE_KEY, sanitizedToken);
        }
        else {
            this.STORAGE.setItem('access_token', sanitizedToken);
        }
        return sanitizedJWT;
    }
    /**
     * @private
     * @param {?} body
     * @return {?}
     */
    prepareJWT(body) {
        /** @type {?} */
        const header = this.getTokenJWT().split('.')[0];
        /** @type {?} */
        const tokenString = header + '.' + btoa(JSON.stringify(body)) + '.';
        return tokenString.replace(/=/g, '');
    }
    /**
     * Efetua o login do usuário, usando o mock.jwt ou a autenticação no SSO (WSO2)
     * @return {?}
     */
    login() {
        if (Wso2IntegrationService.userIsMocked()) {
            /** @type {?} */
            const token = MapaEnviromentService.get().mock.jwt;
            this.STORAGE.setItem(this.MAPA_MOCK_STORAGE_KEY, token);
            this.loadSubject().catch((/**
             * @param {?} reason
             * @return {?}
             */
            reason => {
                console.error('Wso2IntegrationService :: login() -> loadSubject()', reason);
            }));
            return;
        }
        this.oauthService.initImplicitFlow();
    }
    /**
     * Finaliza a sessão do usuário
     * @return {?}
     */
    logout() {
        /** @type {?} */
        const config = MapaEnviromentService.get();
        /** @type {?} */
        const idToken = this.oauthService.getIdToken();
        /** @type {?} */
        const redirectUri = config.sso.redirectUri;
        /** @type {?} */
        const logoutUri = config.sso.serverUrl.concat('/oidc/logout');
        this.STORAGE.clear();
        if (Wso2IntegrationService.userIsMocked()) {
            this.usuario.next(null);
            this.modulos.next([]);
            this.router.navigateByUrl('/').catch((/**
             * @param {?} reason
             * @return {?}
             */
            reason => console.error(reason)));
            return;
        }
        // Limpa dados
        this.oauthService.logOut();
        // Fazer logout no SSO
        // https://docs.wso2.com/display/IS540/OpenID+Connect+Logout+URL+Redirection
        window.location.href = `${logoutUri}?id_token_hint=${idToken}&post_logout_redirect_uri=${redirectUri}&state=1`;
    }
    /**
     * Verifica se o usuário está logado
     * @return {?}
     */
    isLoggedIn() {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const jwt = this.getTokenJWT();
            if (!!jwt) {
                resolve(true);
            }
            else {
                resolve(false);
            }
        }));
    }
    /**
     * @param {?} accessToken
     * @return {?}
     */
    changeAccessToken(accessToken) {
        /** @type {?} */
        const jwt = this.getJWT();
        if (!!jwt) {
            jwt.ACCESS_TOKEN = accessToken;
            jwt.VALIDO = new Date((+new Date()) + 3500000).toISOString();
            /** @type {?} */
            const newTokenJWT = this.prepareJWT(jwt);
            if (Wso2IntegrationService.userIsMocked()) {
                this.STORAGE.setItem(this.MAPA_MOCK_STORAGE_KEY, newTokenJWT);
            }
            else {
                this.STORAGE.setItem('access_token', newTokenJWT);
            }
        }
    }
    /**
     * Obtém a representação do usuário solicitante da requisição.
     *
     * Válido apenas para o "MAPA-JWT-Assertion", proveniente do WSO2
     * @private
     * @return {?}
     */
    loadSubject() {
        if (this.runningLoadSuject) {
            return Promise.resolve();
        }
        this.runningLoadSuject = true;
        console.log('Wso2IntegrationService :: loadSubject');
        /** @type {?} */
        const jwt = this.sanitizeTokenJWT();
        /** @type {?} */
        const modulosUsuario = new Set();
        /** @type {?} */
        let usuarioLogado;
        // Aplicação
        return this.aplicacaoAPI.obterAplicacao()
            .then((/**
         * @param {?} aplicacaoAtual
         * @return {?}
         */
        aplicacaoAtual => {
            console.log('Wso2IntegrationService :: loadSubject - Aplicação: ', aplicacaoAtual);
            this.aplicacao.next(aplicacaoAtual);
        }))
            // Módulos públicos
            .then((/**
         * @return {?}
         */
        () => {
            return this.modulosAPI.obterModulosPublicos().then((/**
             * @param {?} modulosPublicos
             * @return {?}
             */
            modulosPublicos => {
                modulosPublicos.forEach((/**
                 * @param {?} modulo
                 * @return {?}
                 */
                (modulo) => {
                    modulosUsuario.add(modulo);
                }));
            }));
        }))
            // Módulos do usuário logado
            .then((/**
         * @return {?}
         */
        () => {
            // Grupos do Usuário (separados por ";" Ex. "Grupos": "15812;20")
            /** @type {?} */
            let idsGruposUsuario = ((jwt && jwt.Grupos) || '').split(';').filter((/**
             * @param {?} value
             * @return {?}
             */
            value => !!value));
            idsGruposUsuario = [...new Set(idsGruposUsuario)];
            console.log('Wso2IntegrationService :: loadSubject - Grupos: ', idsGruposUsuario);
            return Promise.all(idsGruposUsuario.map((/**
             * @param {?} idGrupo
             * @return {?}
             */
            idGrupo => {
                return this.modulosAPI.obterModulosGrupo(+idGrupo);
            }))).then((/**
             * @param {?} arrayTodosModulos
             * @return {?}
             */
            (arrayTodosModulos) => {
                arrayTodosModulos.forEach((/**
                 * @param {?} modulosPorGrupo
                 * @return {?}
                 */
                (modulosPorGrupo) => {
                    modulosPorGrupo.forEach((/**
                     * @param {?} modulo
                     * @return {?}
                     */
                    (modulo) => {
                        modulosUsuario.add(modulo);
                    }));
                }));
            })).catch(console.error);
        }))
            // Printa os módulos (Públicos & Privados)
            .then((/**
         * @return {?}
         */
        () => {
            console.log('Wso2IntegrationService :: loadSubject - Módulos: ', modulosUsuario);
            this.modulos.next([...modulosUsuario]);
            return Promise.resolve();
        }))
            // Usuário
            .then((/**
         * @return {?}
         */
        () => {
            usuarioLogado = new Usuario();
            if (!!jwt) {
                usuarioLogado.username = jwt.Nome;
                usuarioLogado.idPessoa = Number.parseInt(jwt.idPessoa, 10);
                usuarioLogado.nome = Wso2IntegrationService.ignoreNullString(jwt.nome);
                usuarioLogado.email = Wso2IntegrationService.ignoreNullString(jwt.email);
                usuarioLogado.documento = Wso2IntegrationService.ignoreNullString(jwt.documento);
                usuarioLogado.idUsuario = Number.parseInt(jwt.idUsuario, 10);
                usuarioLogado.perfis = [];
                // S - Usuário de Banco Ativo, A - Usuário de AD, E - Usuário Externo de AD (login termina com .ex)
                usuarioLogado.ativo = ['S', 'A', 'E'].includes(Wso2IntegrationService.ignoreNullString(jwt.ativo));
                return this.wso2Client.get('/api/v1/seguranca/grupos').toPromise()
                    .then((/**
                 * @param {?} resposta
                 * @return {?}
                 */
                resposta => {
                    if (!!resposta.conteudo && Array.isArray(resposta.conteudo)) {
                        usuarioLogado.perfis = resposta.conteudo;
                    }
                    else {
                        console.log('Wso2IntegrationService :: loadSubject - Perfis usuários: ', resposta);
                    }
                })).catch((/**
                 * @param {?} reason
                 * @return {?}
                 */
                reason => {
                    console.error('Wso2IntegrationService :: loadSubject - Perfis usuários: ', reason);
                })).finally((/**
                 * @return {?}
                 */
                () => {
                    console.log('Wso2IntegrationService :: loadSubject - Usuário: ', usuarioLogado);
                    this.usuario.next(usuarioLogado);
                    this.runningLoadSuject = false;
                    return Promise.resolve();
                }));
            }
            else {
                usuarioLogado.username = 'usuariointernet';
                usuarioLogado.nome = 'Anônimo';
                usuarioLogado.perfis = [];
                usuarioLogado.ativo = true;
                console.log('Wso2IntegrationService :: loadSubject - Usuário: ', usuarioLogado);
                this.usuario.next(usuarioLogado);
                this.runningLoadSuject = false;
                return Promise.resolve();
            }
        }));
    }
    /**
     * @private
     * @return {?}
     */
    configureOauthImplicitFlowAuthentication() {
        /** @type {?} */
        const sso = MapaEnviromentService.get().sso;
        /** @type {?} */
        const authConfig = {
            issuer: sso.issuer,
            clientId: sso.clientId,
            tokenEndpoint: sso.serverUrl.concat(sso.tokenEndpoint),
            jwksEndpoint: sso.serverUrl.concat(sso.jwksEndpoint),
            jwks: sso.jwks,
            userinfoEndpoint: sso.serverUrl.concat(sso.userinfoEndpoint),
            showDebugInformation: sso.showDebugInformation,
            loginUrl: sso.serverUrl.concat(sso.authorizationEndpoint),
            requireHttps: sso.requireHttps,
            disableAtHashCheck: true,
            redirectUri: sso.redirectUri,
            // Parametros genéricos
            scope: 'openid profile',
            responseType: 'id_token token'
        };
        this.oauthService.setStorage(this.STORAGE);
        this.oauthService.configure(authConfig);
        // Somente habilita a validação se o jwks estiver definido nas configs
        if (authConfig.jwks) {
            this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        }
    }
}
Wso2IntegrationService.ɵfac = function Wso2IntegrationService_Factory(t) { return new (t || Wso2IntegrationService)(ɵngcc0.ɵɵinject(ɵngcc2.OAuthService), ɵngcc0.ɵɵinject(WSO2), ɵngcc0.ɵɵinject(AplicacaoAPI), ɵngcc0.ɵɵinject(GruposAPI), ɵngcc0.ɵɵinject(ModulosAPI), ɵngcc0.ɵɵinject(ɵngcc3.Router)); };
/** @nocollapse */
Wso2IntegrationService.ctorParameters = () => [
    { type: OAuthService },
    { type: WSO2 },
    { type: AplicacaoAPI },
    { type: GruposAPI },
    { type: ModulosAPI },
    { type: Router }
];
/** @nocollapse */ Wso2IntegrationService.ɵprov = ɵɵdefineInjectable({ factory: function Wso2IntegrationService_Factory() { return new Wso2IntegrationService(ɵɵinject(OAuthService), ɵɵinject(WSO2), ɵɵinject(AplicacaoAPI), ɵɵinject(GruposAPI), ɵɵinject(ModulosAPI), ɵɵinject(Router)); }, token: Wso2IntegrationService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Wso2IntegrationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.OAuthService }, { type: WSO2 }, { type: AplicacaoAPI }, { type: GruposAPI }, { type: ModulosAPI }, { type: ɵngcc3.Router }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.STORAGE;
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.runningLoadSuject;
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.MAPA_MOCK_STORAGE_KEY;
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.wso2Client;
    /** @type {?} */
    Wso2IntegrationService.prototype.aplicacao;
    /** @type {?} */
    Wso2IntegrationService.prototype.modulos;
    /** @type {?} */
    Wso2IntegrationService.prototype.usuario;
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.oauthService;
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.wso2;
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.aplicacaoAPI;
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.gruposAPI;
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.modulosAPI;
    /**
     * @type {?}
     * @private
     */
    Wso2IntegrationService.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/feature/auth/auth.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthComponent {
    /**
     * @param {?} formBuilder
     * @param {?} route
     * @param {?} router
     * @param {?} wso2IntegrationService
     */
    constructor(formBuilder, route, router, wso2IntegrationService) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.wso2IntegrationService = wso2IntegrationService;
        this.loading = false;
        this.submitted = false;
        this.error = '';
    }
    // convenience getter for easy access to form fields
    /**
     * @return {?}
     */
    get f() {
        return this.loginForm.controls;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
        // reset login status
        this.wso2IntegrationService.logout();
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }
    /**
     * @return {?}
     */
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }
        this.loading = true;
        this.wso2IntegrationService.login();
    }
}
AuthComponent.ɵfac = function AuthComponent_Factory(t) { return new (t || AuthComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(Wso2IntegrationService)); };
AuthComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthComponent, selectors: [["mapa-auth"]], decls: 31, vars: 22, consts: [[1, "p-grid", "p-justify-center"], [1, "p-col", "p-col-align-center"], [1, "p-col", 3, "formGroup", "ngSubmit"], ["header", "Autentica\u00E7\u00E3o Corporativa"], [1, "ui-grid", "ui-grid-responsive", "ui-grid-pad", "ui-fluid", 2, "margin", "10px 0"], [1, "ui-grid-row"], [1, "ui-grid-col-2"], [1, "ui-grid-col-6"], ["pInputText", "", "type", "text", "formControlName", "username", 3, "placeholder"], [1, "ui-grid-col-4"], ["severity", "error", 3, "text", 4, "ngIf"], ["pInputText", "", "type", "password", "formControlName", "password", 3, "placeholder"], ["pButton", "", "type", "submit", 3, "label", "disabled"], ["severity", "error", 3, "text"]], template: function AuthComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "p-toast");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 0);
        ɵngcc0.ɵɵelementStart(4, "form", 2);
        ɵngcc0.ɵɵlistener("ngSubmit", function AuthComponent_Template_form_ngSubmit_4_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵelementStart(5, "p-panel", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelement(12, "input", 8);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 9);
        ɵngcc0.ɵɵtemplate(15, AuthComponent_p_message_15_Template, 2, 3, "p-message", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 5);
        ɵngcc0.ɵɵelementStart(17, "div", 6);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 7);
        ɵngcc0.ɵɵelement(21, "input", 11);
        ɵngcc0.ɵɵpipe(22, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 9);
        ɵngcc0.ɵɵtemplate(24, AuthComponent_p_message_24_Template, 2, 3, "p-message", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 5);
        ɵngcc0.ɵɵelement(26, "div", 6);
        ɵngcc0.ɵɵelementStart(27, "div", 7);
        ɵngcc0.ɵɵelement(28, "button", 12);
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(30, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(21, _c0));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.loginForm);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 11, "CORE.AUTH.LOGIN"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(13, 13, "CORE.AUTH.LOGIN_PLACEHOLDER"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loginForm.controls["username"].valid && ctx.loginForm.controls["username"].dirty);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(19, 15, "CORE.AUTH.PASSWORD"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(22, 17, "CORE.AUTH.PASSWORD_PLACEHOLDER"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loginForm.controls["password"].valid && ctx.loginForm.controls["password"].dirty);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("label", ɵngcc0.ɵɵpipeBind1(29, 19, "CORE.AUTH.CONFIRM"))("disabled", !ctx.loginForm.valid);
    } }, directives: [ɵngcc5.Toast, ɵngcc4.ɵangular_packages_forms_forms_y, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc6.Panel, ɵngcc4.DefaultValueAccessor, ɵngcc7.InputText, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc8.NgIf, ɵngcc9.ButtonDirective, ɵngcc10.UIMessage], pipes: [ɵngcc11.TranslatePipe], styles: ["form[_ngcontent-%COMP%]{max-width:480px}"] });
/** @nocollapse */
AuthComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: ActivatedRoute },
    { type: Router },
    { type: Wso2IntegrationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthComponent, [{
        type: Component,
        args: [{
                selector: 'mapa-auth',
                template: "<div class=\"p-grid p-justify-center\">\r\n    <div class=\"p-col p-col-align-center\">\r\n        <p-toast [style]=\"{marginTop: '80px'}\"></p-toast>\r\n    </div>\r\n</div>\r\n<div class=\"p-grid p-justify-center\">\r\n    <form [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit()\" class=\"p-col\">\r\n        <p-panel header=\"Autentica\u00E7\u00E3o Corporativa\">\r\n            <div class=\"ui-grid ui-grid-responsive ui-grid-pad ui-fluid\" style=\"margin: 10px 0\">\r\n                <div class=\"ui-grid-row\">\r\n                    <div class=\"ui-grid-col-2\">\r\n                        {{ 'CORE.AUTH.LOGIN' | translate }}\r\n                    </div>\r\n                    <div class=\"ui-grid-col-6\">\r\n                        <input pInputText type=\"text\" formControlName=\"username\"\r\n                               [placeholder]=\"'CORE.AUTH.LOGIN_PLACEHOLDER' | translate\"/>\r\n                    </div>\r\n                    <div class=\"ui-grid-col-4\">\r\n                        <p-message severity=\"error\" [text]=\"'CORE.AUTH.REQUIRED' | translate\"\r\n                                   *ngIf=\"!loginForm.controls['username'].valid&&loginForm.controls['username'].dirty\"></p-message>\r\n                    </div>\r\n                </div>\r\n                <div class=\"ui-grid-row\">\r\n                    <div class=\"ui-grid-col-2\">\r\n                        {{ 'CORE.AUTH.PASSWORD' | translate }}\r\n                    </div>\r\n                    <div class=\"ui-grid-col-6\">\r\n                        <input pInputText type=\"password\" formControlName=\"password\"\r\n                               [placeholder]=\"'CORE.AUTH.PASSWORD_PLACEHOLDER' | translate\"/>\r\n                    </div>\r\n                    <div class=\"ui-grid-col-4\">\r\n                        <p-message severity=\"error\" [text]=\"'CORE.AUTH.REQUIRED' | translate\"\r\n                                   *ngIf=\"!loginForm.controls['password'].valid&&loginForm.controls['password'].dirty\"></p-message>\r\n                    </div>\r\n                </div>\r\n                <div class=\"ui-grid-row\">\r\n                    <div class=\"ui-grid-col-2\"></div>\r\n                    <div class=\"ui-grid-col-6\">\r\n                        <button pButton type=\"submit\" [label]=\"'CORE.AUTH.CONFIRM' | translate\"\r\n                                [disabled]=\"!loginForm.valid\"></button>\r\n                    </div>\r\n                    <div class=\"ui-grid-col-4\"></div>\r\n                </div>\r\n            </div>\r\n        </p-panel>\r\n    </form>\r\n</div>\r\n",
                styles: ["form{max-width:480px}"]
            }]
    }], function () { return [{ type: ɵngcc4.FormBuilder }, { type: ɵngcc3.ActivatedRoute }, { type: ɵngcc3.Router }, { type: Wso2IntegrationService }]; }, null); })();
if (false) {
    /** @type {?} */
    AuthComponent.prototype.loginForm;
    /** @type {?} */
    AuthComponent.prototype.loading;
    /** @type {?} */
    AuthComponent.prototype.submitted;
    /** @type {?} */
    AuthComponent.prototype.returnUrl;
    /** @type {?} */
    AuthComponent.prototype.error;
    /**
     * @type {?}
     * @private
     */
    AuthComponent.prototype.formBuilder;
    /**
     * @type {?}
     * @private
     */
    AuthComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    AuthComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    AuthComponent.prototype.wso2IntegrationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/layout/public-layout/public-layout.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PublicLayoutComponent {
    constructor() {
        this.show$ = new BehaviorSubject(false);
        // Só exibe após a configuração ser definida pela aplicação
        MapaEnviromentService.get((/**
         * @return {?}
         */
        () => {
            this.show$.next(true);
        }));
    }
}
PublicLayoutComponent.ɵfac = function PublicLayoutComponent_Factory(t) { return new (t || PublicLayoutComponent)(); };
PublicLayoutComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PublicLayoutComponent, selectors: [["mapa-public-layout"]], decls: 2, vars: 3, consts: [[4, "ngIf"], [1, "mapa-content-container"]], template: function PublicLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PublicLayoutComponent_div_0_Template, 4, 0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.show$));
    } }, directives: function () { return [ɵngcc8.NgIf, HeaderComponent, ɵngcc3.RouterOutlet]; }, pipes: function () { return [ɵngcc8.AsyncPipe]; }, styles: [""] });
/** @nocollapse */
PublicLayoutComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PublicLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'mapa-public-layout',
                template: "<div *ngIf=\"(show$ | async)\">\r\n    <mapa-header></mapa-header>\r\n    <div class=\"mapa-content-container\">\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    PublicLayoutComponent.prototype.show$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/feature/auth/auth.routing.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0 = {
    breadcrumbs: 'Login'
};
/** @type {?} */
const authRoutes = [
    {
        path: 'auth',
        component: PublicLayoutComponent,
        data: ɵ0,
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' },
            {
                path: 'login',
                component: AuthComponent
            }
        ]
    }
];
/** @type {?} */
const AuthRouting = RouterModule.forChild(authRoutes);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/feature/auth/auth.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthModule {
}
AuthModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AuthModule_Factory(t) { return new (t || AuthModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            ToastModule,
            PanelModule,
            ButtonModule,
            InputTextModule,
            MessageModule,
            TranslateModule,
            AuthRouting
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthModule, { declarations: function () { return [AuthComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ToastModule,
        PanelModule,
        ButtonModule,
        InputTextModule,
        MessageModule,
        TranslateModule, ɵngcc3.RouterModule]; }, exports: function () { return [AuthComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    ToastModule,
                    PanelModule,
                    ButtonModule,
                    InputTextModule,
                    MessageModule,
                    TranslateModule,
                    AuthRouting
                ],
                declarations: [AuthComponent],
                exports: [AuthComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/util/diacritics.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable:max-line-length */
/** @type {?} */
const replacementList = [
    {
        base: ' ',
        chars: '\u00A0',
    }, {
        base: '0',
        chars: '\u07C0',
    }, {
        base: 'A',
        chars: '\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F',
    }, {
        base: 'AA',
        chars: '\uA732',
    }, {
        base: 'AE',
        chars: '\u00C6\u01FC\u01E2',
    }, {
        base: 'AO',
        chars: '\uA734',
    }, {
        base: 'AU',
        chars: '\uA736',
    }, {
        base: 'AV',
        chars: '\uA738\uA73A',
    }, {
        base: 'AY',
        chars: '\uA73C',
    }, {
        base: 'B',
        chars: '\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181',
    }, {
        base: 'C',
        chars: '\u24b8\uff23\uA73E\u1E08\u0106\u0043\u0108\u010A\u010C\u00C7\u0187\u023B',
    }, {
        base: 'D',
        chars: '\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779',
    }, {
        base: 'Dh',
        chars: '\u00D0',
    }, {
        base: 'DZ',
        chars: '\u01F1\u01C4',
    }, {
        base: 'Dz',
        chars: '\u01F2\u01C5',
    }, {
        base: 'E',
        chars: '\u025B\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07',
    }, {
        base: 'F',
        chars: '\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B',
    }, {
        base: 'G',
        chars: '\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262',
    }, {
        base: 'H',
        chars: '\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D',
    }, {
        base: 'I',
        chars: '\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197',
    }, {
        base: 'J',
        chars: '\u24BF\uFF2A\u0134\u0248\u0237',
    }, {
        base: 'K',
        chars: '\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2',
    }, {
        base: 'L',
        chars: '\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780',
    }, {
        base: 'LJ',
        chars: '\u01C7',
    }, {
        base: 'Lj',
        chars: '\u01C8',
    }, {
        base: 'M',
        chars: '\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB',
    }, {
        base: 'N',
        chars: '\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E',
    }, {
        base: 'NJ',
        chars: '\u01CA',
    }, {
        base: 'Nj',
        chars: '\u01CB',
    }, {
        base: 'O',
        chars: '\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C',
    }, {
        base: 'OE',
        chars: '\u0152',
    }, {
        base: 'OI',
        chars: '\u01A2',
    }, {
        base: 'OO',
        chars: '\uA74E',
    }, {
        base: 'OU',
        chars: '\u0222',
    }, {
        base: 'P',
        chars: '\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754',
    }, {
        base: 'Q',
        chars: '\u24C6\uFF31\uA756\uA758\u024A',
    }, {
        base: 'R',
        chars: '\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782',
    }, {
        base: 'S',
        chars: '\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784',
    }, {
        base: 'T',
        chars: '\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786',
    }, {
        base: 'Th',
        chars: '\u00DE',
    }, {
        base: 'TZ',
        chars: '\uA728',
    }, {
        base: 'U',
        chars: '\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244',
    }, {
        base: 'V',
        chars: '\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245',
    }, {
        base: 'VY',
        chars: '\uA760',
    }, {
        base: 'W',
        chars: '\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72',
    }, {
        base: 'X',
        chars: '\u24CD\uFF38\u1E8A\u1E8C',
    }, {
        base: 'Y',
        chars: '\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE',
    }, {
        base: 'Z',
        chars: '\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762',
    }, {
        base: 'a',
        chars: '\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251',
    }, {
        base: 'aa',
        chars: '\uA733',
    }, {
        base: 'ae',
        chars: '\u00E6\u01FD\u01E3',
    }, {
        base: 'ao',
        chars: '\uA735',
    }, {
        base: 'au',
        chars: '\uA737',
    }, {
        base: 'av',
        chars: '\uA739\uA73B',
    }, {
        base: 'ay',
        chars: '\uA73D',
    }, {
        base: 'b',
        chars: '\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182',
    }, {
        base: 'c',
        chars: '\uFF43\u24D2\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184',
    }, {
        base: 'd',
        chars: '\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA',
    }, {
        base: 'dh',
        chars: '\u00F0',
    }, {
        base: 'dz',
        chars: '\u01F3\u01C6',
    }, {
        base: 'e',
        chars: '\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD',
    }, {
        base: 'f',
        chars: '\u24D5\uFF46\u1E1F\u0192',
    }, {
        base: 'ff',
        chars: '\uFB00',
    }, {
        base: 'fi',
        chars: '\uFB01',
    }, {
        base: 'fl',
        chars: '\uFB02',
    }, {
        base: 'ffi',
        chars: '\uFB03',
    }, {
        base: 'ffl',
        chars: '\uFB04',
    }, {
        base: 'g',
        chars: '\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79',
    }, {
        base: 'h',
        chars: '\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265',
    }, {
        base: 'hv',
        chars: '\u0195',
    }, {
        base: 'i',
        chars: '\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131',
    }, {
        base: 'j',
        chars: '\u24D9\uFF4A\u0135\u01F0\u0249',
    }, {
        base: 'k',
        chars: '\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3',
    }, {
        base: 'l',
        chars: '\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D',
    }, {
        base: 'lj',
        chars: '\u01C9',
    }, {
        base: 'm',
        chars: '\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F',
    }, {
        base: 'n',
        chars: '\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509',
    }, {
        base: 'nj',
        chars: '\u01CC',
    }, {
        base: 'o',
        chars: '\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\uA74B\uA74D\u0275\u0254\u1D11',
    }, {
        base: 'oe',
        chars: '\u0153',
    }, {
        base: 'oi',
        chars: '\u01A3',
    }, {
        base: 'oo',
        chars: '\uA74F',
    }, {
        base: 'ou',
        chars: '\u0223',
    }, {
        base: 'p',
        chars: '\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1',
    }, {
        base: 'q',
        chars: '\u24E0\uFF51\u024B\uA757\uA759',
    }, {
        base: 'r',
        chars: '\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783',
    }, {
        base: 's',
        chars: '\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282',
    }, {
        base: 'ss',
        chars: '\xDF',
    }, {
        base: 't',
        chars: '\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787',
    }, {
        base: 'th',
        chars: '\u00FE',
    }, {
        base: 'tz',
        chars: '\uA729',
    }, {
        base: 'u',
        chars: '\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289',
    }, {
        base: 'v',
        chars: '\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C',
    }, {
        base: 'vy',
        chars: '\uA761',
    }, {
        base: 'w',
        chars: '\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73',
    }, {
        base: 'x',
        chars: '\u24E7\uFF58\u1E8B\u1E8D',
    }, {
        base: 'y',
        chars: '\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF',
    }, {
        base: 'z',
        chars: '\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763',
    }
];
/* tslint:enable:max-line-length */
/** @type {?} */
const diacriticsMap = {};
for (let i = 0; i < replacementList.length; i += 1) {
    /** @type {?} */
    const chars = replacementList[i].chars;
    for (let j = 0; j < chars.length; j += 1) {
        diacriticsMap[chars[j]] = replacementList[i].base;
    }
}
/**
 * @param {?} str
 * @return {?}
 */
function removeDiacritics(str) {
    if (!str) {
        return '';
    }
    return str.replace(/[^\u0000-\u007e]/g, (/**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return diacriticsMap[c] || c;
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/component/breadcrumb/breadcrumb.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BreadcrumbComponent {
    /**
     * @param {?} wso2IntegrationService
     * @param {?} translate
     * @param {?} route
     * @param {?} router
     */
    constructor(wso2IntegrationService, translate, route, router) {
        this.wso2IntegrationService = wso2IntegrationService;
        this.translate = translate;
        this.route = route;
        this.router = router;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.subscriptionNavigationEnd = this.router.events
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event instanceof NavigationEnd)))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            this.updateItems();
        }));
        this.subscriptionAnimation = this.router.events.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            if (event instanceof RouteConfigLoadStart) {
                this.loadingRouteConfig = true;
            }
            else if (event instanceof RouteConfigLoadEnd) {
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    this.loadingRouteConfig = false;
                }), 500);
            }
        }));
        this.subscriptionModulos = this.wso2IntegrationService.modulos.subscribe({
            next: (/**
             * @param {?} modulos
             * @return {?}
             */
            modulos => {
                this.modulos = modulos.filter((/**
                 * @param {?} modulo
                 * @return {?}
                 */
                modulo => !!modulo.pai));
                this.updateItems();
            })
        });
        this.home = { icon: 'pi pi-home' };
        this.translate.onLangChange.subscribe((/**
         * @param {?} item
         * @return {?}
         */
        item => {
            this.updateItems();
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptionNavigationEnd.unsubscribe();
        this.subscriptionAnimation.unsubscribe();
        this.subscriptionModulos.unsubscribe();
    }
    /**
     * @return {?}
     */
    updateItems() {
        if (MapaEnviromentService.get().debug) {
            console.group('Chave para i18n Breadcrumb');
        }
        // const url = this.router.url.split('?')[0];
        /** @type {?} */
        const url = this.getRouteConfig();
        /** @type {?} */
        const modulo = this.modulos.find((/**
         * @param {?} item
         * @return {?}
         */
        item => item.acao === url));
        /** @type {?} */
        let newitems;
        if (modulo) {
            /** @type {?} */
            const navItem = (/** @type {?} */ ({
                id: `${modulo.pai}`,
                label: modulo.nome
            }));
            newitems = this.getItemsForModulo(navItem).reverse();
        }
        else {
            /** @type {?} */
            const breadcrumbs = this.getBreadcrumbs(this.route.snapshot.root).filter((/**
             * @param {?} item
             * @return {?}
             */
            item => !!item));
            newitems = breadcrumbs
                .map((/**
             * @param {?} breadcrumb
             * @return {?}
             */
            (breadcrumb) => {
                return (/** @type {?} */ ({ label: breadcrumb }));
            })).reverse();
        }
        /** @type {?} */
        let parent = '';
        newitems = newitems.map((/**
         * @param {?} item
         * @param {?} i
         * @return {?}
         */
        (item, i) => {
            /** @type {?} */
            let key = `CORE.HEADER.NAVBAR.MENU${parent}.${this.convertKey(item.label)}`;
            if (i + 1 < newitems.length) {
                if (MapaEnviromentService.get().debug) {
                    key = `${key}_`;
                }
            }
            if (MapaEnviromentService.get().debug) {
                console.log(key);
            }
            /** @type {?} */
            const newLabel = this.translate.instant(key);
            if (newLabel !== key) {
                item.label = newLabel;
            }
            parent = parent + '.' + this.convertKey(item.label);
            return item;
        }));
        this.items = newitems;
        if (MapaEnviromentService.get().debug) {
            console.groupEnd();
        }
    }
    /**
     * @private
     * @return {?}
     */
    getRouteConfig() {
        /** @type {?} */
        let routeConfig = '';
        /** @type {?} */
        let currentRoute = this.router.routerState.root;
        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
            if (!!currentRoute.routeConfig && !!currentRoute.routeConfig.path) {
                routeConfig += ('/' + currentRoute.routeConfig.path);
            }
        }
        return routeConfig;
    }
    /**
     * @param {?} item
     * @return {?}
     */
    getItemsForModulo(item) {
        /** @type {?} */
        let newItem = [item];
        /** @type {?} */
        const parent = this.modulos.find((/**
         * @param {?} modulo
         * @return {?}
         */
        modulo => `${modulo.id}` === item.id));
        if (parent) {
            /** @type {?} */
            const newMenuItem = (/** @type {?} */ ({
                id: `${parent.pai}`,
                label: parent.nome
            }));
            if (parent.tipo === TIPO_MODULO.ITEM_DE_MENU && parent.acao) {
                newMenuItem.routerLink = parent.acao;
            }
            newItem = newItem.concat(this.getItemsForModulo(newMenuItem));
        }
        return newItem;
    }
    /**
     * @param {?} snapshot
     * @return {?}
     */
    getBreadcrumbs(snapshot) {
        /** @type {?} */
        let data = [];
        if (snapshot.firstChild) {
            data = data.concat(this.getBreadcrumbs(snapshot.firstChild));
        }
        if (snapshot.data['breadcrumbs']) {
            data.push(snapshot.data['breadcrumbs']);
        }
        return data;
    }
    /**
     * @private
     * @param {?} text
     * @return {?}
     */
    convertKey(text) {
        return removeDiacritics(text).toUpperCase().replace(/\s/gi, '_');
    }
}
BreadcrumbComponent.ɵfac = function BreadcrumbComponent_Factory(t) { return new (t || BreadcrumbComponent)(ɵngcc0.ɵɵdirectiveInject(Wso2IntegrationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc11.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router)); };
BreadcrumbComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbComponent, selectors: [["mapa-breadcrumb"]], decls: 3, vars: 4, consts: [[1, "mapa-breadcrumb-container"], [3, "home", "model", "styleClass"], ["mode", "indeterminate", 3, "styleClass"]], template: function BreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "p-breadcrumb", 1);
        ɵngcc0.ɵɵelement(2, "p-progressBar", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("home", ctx.home)("model", ctx.items)("styleClass", "mapa-breadcrumb");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("styleClass", ctx.loadingRouteConfig ? "mapa-loading" : "mapa-loading-hidden");
    } }, directives: [ɵngcc12.Breadcrumb, ɵngcc13.ProgressBar], styles: [""], encapsulation: 2 });
/** @nocollapse */
BreadcrumbComponent.ctorParameters = () => [
    { type: Wso2IntegrationService },
    { type: TranslateService },
    { type: ActivatedRoute },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'mapa-breadcrumb',
                template: "<div class=\"mapa-breadcrumb-container\">\r\n    <p-breadcrumb [home]=\"home\" [model]=\"items\" [styleClass]=\"'mapa-breadcrumb'\"></p-breadcrumb>\r\n    <p-progressBar [styleClass]=\"loadingRouteConfig ? 'mapa-loading' : 'mapa-loading-hidden'\" mode=\"indeterminate\"></p-progressBar>\r\n</div>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [""]
            }]
    }], function () { return [{ type: Wso2IntegrationService }, { type: ɵngcc11.TranslateService }, { type: ɵngcc3.ActivatedRoute }, { type: ɵngcc3.Router }]; }, null); })();
if (false) {
    /** @type {?} */
    BreadcrumbComponent.prototype.items;
    /** @type {?} */
    BreadcrumbComponent.prototype.home;
    /** @type {?} */
    BreadcrumbComponent.prototype.loadingRouteConfig;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbComponent.prototype.subscriptionNavigationEnd;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbComponent.prototype.subscriptionAnimation;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbComponent.prototype.subscriptionModulos;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbComponent.prototype.modulos;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbComponent.prototype.wso2IntegrationService;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/component/header/header.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HeaderComponent {
    /**
     * @param {?} breakpointObserver
     * @param {?} translateService
     * @param {?} wso2IntegrationService
     * @param {?} route
     * @param {?} router
     */
    constructor(breakpointObserver, translateService, wso2IntegrationService, route, router) {
        this.breakpointObserver = breakpointObserver;
        this.translateService = translateService;
        this.wso2IntegrationService = wso2IntegrationService;
        this.route = route;
        this.router = router;
        this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        result => result.matches)));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.baseApp = '/' + MapaEnviromentService.get().contexto || `/`;
        this.ambiente = MapaEnviromentService.get().ambiente;
        this.subscriptionAplicacao = this.wso2IntegrationService.aplicacao.subscribe({ next: (/**
             * @param {?} aplicacao
             * @return {?}
             */
            aplicacao => this.aplicacao = aplicacao) });
        this.subscriptionUsuario = this.wso2IntegrationService.usuario.subscribe({ next: (/**
             * @param {?} item
             * @return {?}
             */
            item => this.usuario = item) });
        this.SubscriptionNavigationEnd = this.router.events
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event instanceof NavigationEnd)))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            this.updateTitle();
        }));
        this.subscriptionIdioma = this.translateService.onLangChange.subscribe((/**
         * @return {?}
         */
        () => {
            this.updateTitle();
        }));
        this.updateTitle();
    }
    /**
     * @return {?}
     */
    updateTitle() {
        /** @type {?} */
        const snapshot = this.getLastRouter(this.route.snapshot);
        if (snapshot.data && snapshot.data['title']) {
            /** @type {?} */
            const pageTitle = snapshot.data['title'];
            /** @type {?} */
            const key = this.convertKey(pageTitle);
            if (MapaEnviromentService.get().debug) {
                console.log(`Chaves para i18n titulo página: ${key}`);
            }
            this.translateService.get(key).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            (data) => {
                if (data && data !== key) {
                    this.pageTitle = data;
                }
                else {
                    this.pageTitle = pageTitle;
                }
            }));
        }
        else {
            this.pageTitle = null;
        }
    }
    /**
     * @private
     * @param {?} snapshot
     * @return {?}
     */
    getLastRouter(snapshot) {
        if (snapshot.firstChild) {
            return this.getLastRouter(snapshot.firstChild);
        }
        else {
            return snapshot;
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.subscriptionUsuario) {
            this.subscriptionUsuario.unsubscribe();
        }
        if (this.subscriptionAplicacao) {
            this.subscriptionAplicacao.unsubscribe();
        }
        if (this.SubscriptionNavigationEnd) {
            this.SubscriptionNavigationEnd.unsubscribe();
        }
        if (this.subscriptionIdioma) {
            this.subscriptionIdioma.unsubscribe();
        }
    }
    /**
     * @private
     * @param {?} text
     * @return {?}
     */
    convertKey(text) {
        return removeDiacritics(text).toUpperCase().replace(/\s/gi, '_');
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc14.BreakpointObserver), ɵngcc0.ɵɵdirectiveInject(ɵngcc11.TranslateService), ɵngcc0.ɵɵdirectiveInject(Wso2IntegrationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router)); };
HeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["mapa-header"]], decls: 20, vars: 18, consts: [[1, "mapa-header-container"], [3, "ngClass"], [1, "mapa-identificacao-ministerio"], ["href", "http://www.brasil.gov.br", "target", "_blank", 1, "mapa-brasil-gov"], ["class", "mapa-ambiente", 4, "ngIf"], [1, "mapa-identificacao-sistema-container"], [1, "mapa-identificacao-sistema"], ["id", "link-pagina-inicial", 3, "title", "routerLink"], ["class", "mapa-dados-login-container", 4, "ngIf"], ["class", "mapa-page-header", 4, "ngIf"], [1, "mapa-ambiente"], [1, "mapa-dados-login-container"], [1, "mapa-dados-login"], ["initialsSize", "2", 3, "name"], [1, "mapa-dados-login-val"], [1, "mapa-dados-login-imagem"], [1, "mapa-page-header"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "a", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, HeaderComponent_span_7_Template, 2, 1, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵelementStart(10, "h1");
        ɵngcc0.ɵɵelementStart(11, "a", 7);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "h2");
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, HeaderComponent_div_16_Template, 6, 2, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(17, "mapa-nav-bar");
        ɵngcc0.ɵɵelement(18, "mapa-breadcrumb");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, HeaderComponent_div_19_Template, 3, 1, "div", 9);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c1, ɵngcc0.ɵɵpipeBind1(2, 10, ctx.isHandset$)));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 12, "CORE.HEADER.MINISTERIO"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ambiente);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(12, 14, "CORE.HEADER.HOME_TITLE"))("routerLink", ctx.baseApp);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.aplicacao ? ctx.aplicacao.nome : "", "\u00A0 ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate2(" ", ctx.aplicacao ? ctx.aplicacao.versao : "", " - ", ctx.aplicacao ? ctx.aplicacao.objetivo : "", "\u00A0 ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.usuario && ctx.usuario.nome);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pageTitle != undefined && ctx.pageTitle != null);
    } }, directives: function () { return [ɵngcc8.NgClass, ɵngcc8.NgIf, ɵngcc3.RouterLinkWithHref, NavBarComponent, BreadcrumbComponent, ɵngcc15.AvatarComponent]; }, pipes: function () { return [ɵngcc8.AsyncPipe, ɵngcc11.TranslatePipe]; }, styles: [""] });
/** @nocollapse */
HeaderComponent.ctorParameters = () => [
    { type: BreakpointObserver },
    { type: TranslateService },
    { type: Wso2IntegrationService },
    { type: ActivatedRoute },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'mapa-header',
                template: "<div class=\"mapa-header-container\">\r\n    <div [ngClass]=\"{'handset' : (isHandset$ | async)}\">\r\n        <div class=\"mapa-identificacao-ministerio\">\r\n            <a class=\"mapa-brasil-gov\" href=\"http://www.brasil.gov.br\"\r\n               target=\"_blank\">{{ 'CORE.HEADER.MINISTERIO' | translate }}</a>\r\n            <span *ngIf=\"ambiente\" class=\"mapa-ambiente\">{{ambiente}}</span>\r\n        </div>\r\n        <div class=\"mapa-identificacao-sistema-container\">\r\n            <div class=\"mapa-identificacao-sistema\">\r\n                <h1>\r\n                    <a id=\"link-pagina-inicial\" [title]=\"'CORE.HEADER.HOME_TITLE' | translate\" [routerLink]=\"baseApp\">\r\n                        {{aplicacao ? aplicacao.nome : ''}}&nbsp;\r\n\r\n                    </a>\r\n                </h1>\r\n                <h2>\r\n                    {{aplicacao ? aplicacao.versao : ''}} - {{aplicacao ? aplicacao.objetivo : ''}}&nbsp;\r\n                </h2>\r\n            </div>\r\n            <div *ngIf=\"usuario && usuario.nome\" class=\"mapa-dados-login-container\">\r\n                <div class=\"mapa-dados-login\">\r\n                    <ngx-avatar [name]=\"usuario.nome\" initialsSize=\"2\"></ngx-avatar>\r\n                    <span class=\"mapa-dados-login-val\">{{usuario.nome}}</span>\r\n                </div>\r\n                <div class=\"mapa-dados-login-imagem\">\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <mapa-nav-bar></mapa-nav-bar>\r\n    <mapa-breadcrumb></mapa-breadcrumb>\r\n</div>\r\n<div class=\"mapa-page-header\" *ngIf=\"pageTitle!=undefined && pageTitle!=null\">\r\n    <h3>{{pageTitle}}</h3>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc14.BreakpointObserver }, { type: ɵngcc11.TranslateService }, { type: Wso2IntegrationService }, { type: ɵngcc3.ActivatedRoute }, { type: ɵngcc3.Router }]; }, null); })();
if (false) {
    /** @type {?} */
    HeaderComponent.prototype.usuario;
    /** @type {?} */
    HeaderComponent.prototype.aplicacao;
    /** @type {?} */
    HeaderComponent.prototype.ambiente;
    /** @type {?} */
    HeaderComponent.prototype.pageTitle;
    /** @type {?} */
    HeaderComponent.prototype.baseApp;
    /** @type {?} */
    HeaderComponent.prototype.isHandset$;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.subscriptionIdioma;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.subscriptionUsuario;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.subscriptionAplicacao;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.SubscriptionNavigationEnd;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.breakpointObserver;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.translateService;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.wso2IntegrationService;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/language.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ILanguage() { }
if (false) {
    /** @type {?} */
    ILanguage.prototype.code;
    /** @type {?} */
    ILanguage.prototype.name;
}
class LanguageService {
    constructor() {
        MapaEnviromentService.get(this.initLanguage.bind(this));
    }
    /**
     * @private
     * @return {?}
     */
    initLanguage() {
        /** @type {?} */
        let defaultLang = {
            code: 'pt-br',
            name: 'Português',
        };
        /** @type {?} */
        const langCode = this.getLanguage();
        if (langCode && this.getLanguages() && this.getLanguages().length > 0) {
            defaultLang = this.getLanguages().find((/**
             * @param {?} item
             * @return {?}
             */
            item => item.code === langCode)) || defaultLang;
            this.saveLanguage(defaultLang.code);
        }
        this.languageSubject = new BehaviorSubject(defaultLang);
        this.language = this.languageSubject.asObservable();
    }
    /**
     * @return {?}
     */
    getCurrentLanguage() {
        return this.languageSubject.value;
    }
    /**
     * @param {?} lang
     * @return {?}
     */
    updateLanguage(lang) {
        this.saveLanguage(lang ? lang.code : null);
        this.languageSubject.next(lang);
    }
    /**
     * @return {?}
     */
    getLanguages() {
        return MapaEnviromentService.get().idiomas || [];
    }
    /**
     * @private
     * @return {?}
     */
    getLanguage() {
        return localStorage.getItem(`lang-${MapaEnviromentService.get().contexto}`);
    }
    /**
     * @private
     * @param {?} codeLanguage
     * @return {?}
     */
    saveLanguage(codeLanguage) {
        localStorage.setItem(`lang-${MapaEnviromentService.get().contexto}`, codeLanguage);
    }
    /**
     * @private
     * @return {?}
     */
    removeLanguage() {
        localStorage.removeItem(`lang-${MapaEnviromentService.get().contexto}`);
    }
}
LanguageService.ɵfac = function LanguageService_Factory(t) { return new (t || LanguageService)(); };
/** @nocollapse */
LanguageService.ctorParameters = () => [];
/** @nocollapse */ LanguageService.ɵprov = ɵɵdefineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(); }, token: LanguageService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LanguageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    LanguageService.prototype.language;
    /** @type {?} */
    LanguageService.prototype.languageSubject;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/component/nav-bar/nav-bar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function MenuItemModulo() { }
if (false) {
    /** @type {?} */
    MenuItemModulo.prototype.modulo;
}
class NavBarComponent {
    /**
     * @param {?} wso2IntegrationService
     * @param {?} appService
     * @param {?} breakpointObserver
     * @param {?} languageService
     * @param {?} translate
     * @param {?} route
     * @param {?} router
     */
    constructor(wso2IntegrationService, appService, breakpointObserver, languageService, translate, route, router) {
        this.wso2IntegrationService = wso2IntegrationService;
        this.appService = appService;
        this.breakpointObserver = breakpointObserver;
        this.languageService = languageService;
        this.translate = translate;
        this.route = route;
        this.router = router;
        this.isHandset$ = this.breakpointObserver.observe(['(max-width: 1024px)']).pipe(map((/**
         * @param {?} result
         * @return {?}
         */
        result => result.matches)));
        this.exibirMenuLateral = false;
        this.nav = [];
        this.navRight = [];
        this.languages = [];
        this.i18nKeyCache = {};
        this.atualizarIdioma = this.atualizarIdioma.bind(this);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.atualizarMenuLateral();
        this.subscriptionUsuario = this.wso2IntegrationService.usuario.subscribe({
            next: (/**
             * @param {?} user
             * @return {?}
             */
            user => {
                this.usuario = user;
                this.atualizarNavegacaoTopo();
                this.atualizarMenuLateral();
            })
        });
        this.subscriptionAplicacao = this.wso2IntegrationService.aplicacao.subscribe({
            next: (/**
             * @param {?} aplicacao
             * @return {?}
             */
            aplicacao => {
                this.aplicacao = aplicacao;
                this.atualizarNomeAplicacao();
            })
        });
        this.subscriptionModulos = this.wso2IntegrationService.modulos.subscribe({
            next: (/**
             * @param {?} modulos
             * @return {?}
             */
            modulos => {
                // Apenas módulos de menu (DOMINIO e ITEM_DE_MENU)
                this.modulos = (modulos || []).filter((/**
                 * @param {?} modulo
                 * @return {?}
                 */
                modulo => {
                    return [TIPO_MODULO.DOMINIO, TIPO_MODULO.ITEM_DE_MENU].includes(modulo.tipo);
                }));
                this.atualizarNavegacaoTopo();
            })
        });
        this.languages = this.languageService.getLanguages().map((/**
         * @param {?} item
         * @return {?}
         */
        item => ({ label: item.name, value: item.code })));
        this.subscriptionIdioma = this.languageService.language.subscribe((/**
         * @param {?} lang
         * @return {?}
         */
        lang => {
            this.language = lang.code;
            this.translate.use(lang.code).pipe(take(1)).subscribe((/**
             * @return {?}
             */
            () => {
                this.atualizarLabelsTela();
                this.atualizarNomeAplicacao();
                this.atualizarNavegacaoTopo();
            }));
        }));
        this.subscriptionNavigationEnd = this.router.events
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event instanceof NavigationEnd)))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            this.exibirMenuLateral = false;
            this.atualizarMenuLateral();
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.subscriptionUsuario) {
            this.subscriptionUsuario.unsubscribe();
        }
        if (this.subscriptionAplicacao) {
            this.subscriptionAplicacao.unsubscribe();
        }
        if (this.subscriptionModulos) {
            this.subscriptionModulos.unsubscribe();
        }
        if (this.subscriptionIdioma) {
            this.subscriptionIdioma.unsubscribe();
        }
        if (this.subscriptionI18n) {
            this.subscriptionI18n.unsubscribe();
        }
        if (this.subscriptionNavigationEnd) {
            this.subscriptionNavigationEnd.unsubscribe();
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    fecharMenuLateral($event) {
        this.exibirMenuLateral = false;
    }
    /**
     * @return {?}
     */
    atualizarIdioma() {
        /** @type {?} */
        const selectLang = this.languageService.getLanguages().find((/**
         * @param {?} item
         * @return {?}
         */
        item => item.code === this.language));
        this.languageService.updateLanguage(selectLang);
    }
    /**
     * Atualiza o nome de apresentação da aplicação quando houver alteração de idioma por exemplo
     * @private
     * @return {?}
     */
    atualizarNomeAplicacao() {
        if (this.aplicacao) {
            /** @type {?} */
            const key = this.obterKeyI18n(this.aplicacao.nome);
            this.translate.get(key)
                .subscribe({
                next: (/**
                 * @param {?} item
                 * @return {?}
                 */
                item => {
                    if (item !== this.obterKeyI18n(item.NM_APLICACAO)) {
                        this.appName = item;
                    }
                    else {
                        this.appName = item.NM_APLICACAO;
                    }
                })
            });
        }
    }
    /**
     * @private
     * @return {?}
     */
    atualizarLabelsTela() {
        forkJoin(this.translate.get('CORE.HEADER.NAVBAR.LOGIN'), this.translate.get('CORE.HEADER.NAVBAR.LOGOUT')).subscribe((/**
         * @param {?} resp
         * @return {?}
         */
        resp => {
            this.navRight = this.navRight.map((/**
             * @param {?} item
             * @return {?}
             */
            item => {
                if (item.id === 'login') {
                    item.label = resp[0];
                }
                if (item.id === 'logout') {
                    item.label = resp[1];
                }
                return item;
            }));
        }));
    }
    /**
     * @private
     * @return {?}
     */
    atualizarMenuLateral() {
        this.wso2IntegrationService.isLoggedIn().then((/**
         * @param {?} isLogged
         * @return {?}
         */
        isLogged => {
            /** @type {?} */
            const snapshot = this.getLastRouter(this.route.snapshot);
            this.navRight = [];
            if (snapshot.data && snapshot.data['navRight']) {
                this.navRight = this.navRight.concat(snapshot.data['navRight']);
            }
            // Botão LOGIN
            if (!isLogged) {
                if (snapshot.data && snapshot.data['navRightLogged']) {
                    this.navRight = this.navRight.concat(snapshot.data['navRightLogged']);
                }
                this.translate.get('CORE.HEADER.NAVBAR.LOGIN')
                    .subscribe((/**
                 * @param {?} login
                 * @return {?}
                 */
                login => {
                    this.navRight = this.navRight.filter((/**
                     * @param {?} item
                     * @return {?}
                     */
                    item => item.id !== 'login'));
                    this.navRight.push({
                        id: 'login',
                        label: login,
                        icon: 'pi pi-fw pi-sign-out',
                        command: (/**
                         * @return {?}
                         */
                        () => {
                            this.exibirMenuLateral = false;
                            this.wso2IntegrationService.login();
                        })
                    });
                }));
            }
            else {
                if (snapshot.data && snapshot.data['navRightNotLogged']) {
                    this.navRight = this.navRight.concat(snapshot.data['navRightNotLogged']);
                }
                this.translate.get('CORE.HEADER.NAVBAR.LOGOUT').subscribe((/**
                 * @param {?} logout
                 * @return {?}
                 */
                logout => {
                    this.navRight = this.navRight.filter((/**
                     * @param {?} item
                     * @return {?}
                     */
                    item => item.id !== 'logout'));
                    this.navRight.push({
                        id: 'logout',
                        label: logout,
                        icon: 'pi pi-fw pi-sign-in',
                        command: (/**
                         * @return {?}
                         */
                        () => {
                            this.exibirMenuLateral = false;
                            this.wso2IntegrationService.logout();
                        })
                    });
                }));
            }
        }));
    }
    /**
     * Atualiza os itens de navegação quando os modulos do usuário forem carregados
     * @private
     * @return {?}
     */
    atualizarNavegacaoTopo() {
        if (!this.modulos) {
            return;
        }
        /** @type {?} */
        const moduloPrincipal = this.modulos.find((/**
         * @param {?} modulo
         * @return {?}
         */
        modulo => !modulo.pai));
        if (moduloPrincipal) {
            /** @type {?} */
            const menuNivelUm = this.modulos
                .filter((/**
             * @param {?} modulo
             * @return {?}
             */
            modulo => modulo.pai === moduloPrincipal.id))
                .sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            (a, b) => a.ordem - b.ordem))
                .map((/**
             * @param {?} modulo
             * @return {?}
             */
            modulo => {
                return {
                    id: `${modulo.id}`,
                    label: modulo.nome,
                    modulo: modulo,
                    automationId: modulo.nome
                };
            }));
            this.nav = this.processarMenuFilho(menuNivelUm);
        }
    }
    /**
     * @private
     * @param {?} menuBase
     * @param {?=} chavePai
     * @return {?}
     */
    processarMenuFilho(menuBase, chavePai = '') {
        return menuBase
            .map((/**
         * @param {?} item
         * @return {?}
         */
        item => {
            /** @type {?} */
            const novaChavePai = chavePai + '.' + this.obterKeyI18n(item.automationId);
            /** @type {?} */
            const filhos = this.modulos
                .filter((/**
             * @param {?} modulo
             * @return {?}
             */
            modulo => `${modulo.pai}` === item.id))
                .sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            (a, b) => a.ordem - b.ordem))
                .map((/**
             * @param {?} modulo
             * @return {?}
             */
            modulo => {
                /** @type {?} */
                const key = `CORE.HEADER.NAVBAR.MENU${novaChavePai}.${this.obterKeyI18n(modulo.nome)}`;
                /** @type {?} */
                const label = this.translate.instant(key);
                return {
                    id: `${modulo.id}`,
                    label: label !== key ? label : modulo.nome,
                    modulo: modulo,
                    automationId: modulo.nome
                };
            }));
            item.items = this.processarMenuFilho(filhos, novaChavePai) || [];
            // Se o item não tiver filho, obtem o link para ele
            if (item.items.length === 0) {
                item.items = null;
                item.routerLink = item.modulo.acao;
            }
            else {
                /** @type {?} */
                const key = `CORE.HEADER.NAVBAR.MENU${novaChavePai}_`;
                /** @type {?} */
                const label = this.translate.instant(key);
                if (label !== key) {
                    item.label = label;
                }
            }
            return item;
        }))
            .filter((/**
         * @param {?} item
         * @return {?}
         */
        item => {
            return !!item.routerLink || (!item.routerLink && item.items && item.items.length > 0);
        }));
    }
    /**
     * Obtém uma chave i18n válido a partir da string informada
     * @private
     * @param {?} text
     * @return {?}
     */
    obterKeyI18n(text) {
        if (!this.i18nKeyCache.hasOwnProperty(text)) {
            this.i18nKeyCache[text] = removeDiacritics(text)
                .toUpperCase()
                .replace(/\s/gi, '_');
        }
        return this.i18nKeyCache[text];
    }
    /**
     * @private
     * @param {?} snapshot
     * @return {?}
     */
    getLastRouter(snapshot) {
        if (snapshot.firstChild) {
            return this.getLastRouter(snapshot.firstChild);
        }
        else {
            return snapshot;
        }
    }
}
NavBarComponent.ɵfac = function NavBarComponent_Factory(t) { return new (t || NavBarComponent)(ɵngcc0.ɵɵdirectiveInject(Wso2IntegrationService), ɵngcc0.ɵɵdirectiveInject(AplicacaoAPI), ɵngcc0.ɵɵdirectiveInject(ɵngcc14.BreakpointObserver), ɵngcc0.ɵɵdirectiveInject(LanguageService), ɵngcc0.ɵɵdirectiveInject(ɵngcc11.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router)); };
NavBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavBarComponent, selectors: [["mapa-nav-bar"]], decls: 5, vars: 6, consts: [[1, "mapa-navbar-container"], ["class", "mapa-navbar-desktop", 4, "ngIf"], ["class", "mapa-navbar-mobile", 4, "ngIf"], [1, "mapa-navbar-desktop"], [3, "model", "styleClass"], [3, "changeRouter"], ["placeholder", "Language", 3, "ngModel", "options", "styleClass", "onChange", "ngModelChange", 4, "ngIf"], [3, "autoDisplay", "model", "styleClass"], ["placeholder", "Language", 3, "ngModel", "options", "styleClass", "onChange", "ngModelChange"], [1, "mapa-navbar-mobile"], [3, "visible", "showCloseIcon", "styleClass", "visibleChange"], [1, "mapa-menubar-mobile-head"], ["initialsSize", "2", "size", "80", 3, "name"], [1, "mapa-dados-login-val"], [1, "mapa-menubar-mobile-content"], [1, "mapa-menubar-mobile-search-nav-item"], [1, "mapa-menubar-mobile-lang"], ["placeholder", "Language", 3, "ngModel", "options", "onChange", "ngModelChange", 4, "ngIf"], ["icon", "pi pi-bars", "pButton", "", "type", "text", 3, "click"], ["placeholder", "Language", 3, "ngModel", "options", "onChange", "ngModelChange"]], template: function NavBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NavBarComponent_div_1_Template, 5, 6, "div", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵtemplate(3, NavBarComponent_div_3_Template, 19, 13, "div", 2);
        ɵngcc0.ɵɵpipe(4, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ɵngcc0.ɵɵpipeBind1(2, 2, ctx.isHandset$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 4, ctx.isHandset$));
    } }, directives: function () { return [ɵngcc8.NgIf, ɵngcc16.Menubar, SearchNavItemComponent, ɵngcc17.Dropdown, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc18.Sidebar, ɵngcc15.AvatarComponent, ɵngcc19.PanelMenu, ɵngcc9.ButtonDirective]; }, pipes: function () { return [ɵngcc8.AsyncPipe, ɵngcc11.TranslatePipe]; }, styles: [""], encapsulation: 2 });
/** @nocollapse */
NavBarComponent.ctorParameters = () => [
    { type: Wso2IntegrationService },
    { type: AplicacaoAPI },
    { type: BreakpointObserver },
    { type: LanguageService },
    { type: TranslateService },
    { type: ActivatedRoute },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavBarComponent, [{
        type: Component,
        args: [{
                selector: 'mapa-nav-bar',
                template: "<div class=\"mapa-navbar-container\">\r\n    <div *ngIf=\"!(isHandset$ | async)\" class=\"mapa-navbar-desktop\">\r\n        <p-menubar [model]=\"nav\" [styleClass]=\"'mapa-menubar'\"></p-menubar>\r\n        <mapa-search-nav-item (changeRouter)=\"fecharMenuLateral($event)\"></mapa-search-nav-item>\r\n        <p-dropdown (onChange)=\"atualizarIdioma()\" *ngIf=\"languages.length > 0\" [(ngModel)]=\"language\"\r\n                    [options]=\"languages\"\r\n                    [styleClass]=\"'mapa-lang'\" placeholder=\"Language\"></p-dropdown>\r\n        <p-menubar [autoDisplay]=\"false\" [model]=\"navRight\" [styleClass]=\"'mapa-menubar'\"></p-menubar>\r\n    </div>\r\n    <div *ngIf=\"isHandset$ | async\" class=\"mapa-navbar-mobile\">\r\n        <p-sidebar [(visible)]=\"exibirMenuLateral\" [showCloseIcon]=\"false\" [styleClass]=\"'mapa-menubar-mobile-sidebar'\">\r\n            <div class=\"mapa-menubar-mobile-head\">\r\n                <div>\r\n                    <ngx-avatar [name]=\"usuario ? usuario.nome : 'MAPA'\" initialsSize=\"2\" size=\"80\"></ngx-avatar>\r\n                </div>\r\n                <div>\r\n               <span\r\n                   class=\"mapa-dados-login-val\">{{usuario ? usuario.nome : 'CORE.HEADER.NOT_AUTHENTICATED' | translate}}</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"mapa-menubar-mobile-content\">\r\n                <div class=\"mapa-menubar-mobile-search-nav-item\">\r\n                    <mapa-search-nav-item (changeRouter)=\"fecharMenuLateral($event)\"></mapa-search-nav-item>\r\n                </div>\r\n                <div class=\"mapa-menubar-mobile-lang\">\r\n                    <p-dropdown (onChange)=\"atualizarIdioma()\" *ngIf=\"languages.length > 0\" [(ngModel)]=\"language\"\r\n                                [options]=\"languages\"\r\n                                placeholder=\"Language\"></p-dropdown>\r\n                </div>\r\n                <p-panelMenu [model]=\"nav\" [styleClass]=\"'mapa-menubar-mobile-nav'\"></p-panelMenu>\r\n                <p-panelMenu [model]=\"navRight\" [styleClass]=\"'mapa-menubar-mobile-nav'\"></p-panelMenu>\r\n            </div>\r\n        </p-sidebar>\r\n        <button (click)=\"exibirMenuLateral = true\" icon=\"pi pi-bars\" pButton type=\"text\"></button>\r\n        <h1>{{appName}}</h1>\r\n    </div>\r\n\r\n</div>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [""]
            }]
    }], function () { return [{ type: Wso2IntegrationService }, { type: AplicacaoAPI }, { type: ɵngcc14.BreakpointObserver }, { type: LanguageService }, { type: ɵngcc11.TranslateService }, { type: ɵngcc3.ActivatedRoute }, { type: ɵngcc3.Router }]; }, null); })();
if (false) {
    /** @type {?} */
    NavBarComponent.prototype.isHandset$;
    /** @type {?} */
    NavBarComponent.prototype.appName;
    /** @type {?} */
    NavBarComponent.prototype.exibirMenuLateral;
    /** @type {?} */
    NavBarComponent.prototype.usuario;
    /** @type {?} */
    NavBarComponent.prototype.aplicacao;
    /** @type {?} */
    NavBarComponent.prototype.nav;
    /** @type {?} */
    NavBarComponent.prototype.navRight;
    /** @type {?} */
    NavBarComponent.prototype.languages;
    /** @type {?} */
    NavBarComponent.prototype.language;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.i18nKeyCache;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.modulos;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.subscriptionUsuario;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.subscriptionAplicacao;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.subscriptionModulos;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.subscriptionIdioma;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.subscriptionI18n;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.subscriptionNavigationEnd;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.wso2IntegrationService;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.appService;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.breakpointObserver;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.languageService;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/component/search-nav-item/search-nav-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SearchNavItemComponent {
    /**
     * @param {?} wso2IntegrationService
     * @param {?} route
     */
    constructor(wso2IntegrationService, route) {
        this.wso2IntegrationService = wso2IntegrationService;
        this.route = route;
        this.resultsMenu = [];
        this.changeRouter = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.updateModulos();
    }
    /**
     * @return {?}
     */
    updateModulos() {
        this.subscriptionModulos = this.wso2IntegrationService.modulos.subscribe({
            next: (/**
             * @param {?} modulos
             * @return {?}
             */
            modulos => {
                this.modulos = modulos.filter((/**
                 * @param {?} modulo
                 * @return {?}
                 */
                modulo => {
                    return modulo.pai !== null && modulo.pai !== undefined && modulo.pai !== 0;
                }));
            })
        });
    }
    /**
     * Busca menu
     * @param {?} event
     * @return {?}
     */
    search(event) {
        /** @type {?} */
        const query = event.query;
        /** @type {?} */
        const regex = new RegExp(query, 'gi');
        this.resultsMenu = this.modulos
            .filter((/**
         * @param {?} modulo
         * @return {?}
         */
        modulo => modulo.tipo === TIPO_MODULO.ITEM_DE_MENU && modulo.acao))
            .map((/**
         * @param {?} modulo
         * @return {?}
         */
        modulo => ({
            label: modulo.nome,
            id: `${modulo.id}`,
            routerLink: modulo.acao
        })))
            .map((/**
         * @param {?} item
         * @return {?}
         */
        item => {
            /** @type {?} */
            const parents = this.getItemsForModulo(item);
            parents.shift();
            item.label = parents.map((/**
             * @param {?} parent
             * @return {?}
             */
            parent => parent.label))
                .reverse()
                .join(' > ');
            return item;
        }))
            .filter((/**
         * @param {?} item
         * @return {?}
         */
        item => regex.test(item.label)));
    }
    /**
     * @param {?} menuItem
     * @return {?}
     */
    onSelect(menuItem) {
        this.searchMenu = null;
        if (menuItem && menuItem.routerLink) {
            this.changeRouter.emit(menuItem);
            this.route.navigate([menuItem.routerLink]);
        }
    }
    /**
     * @param {?} item
     * @return {?}
     */
    getItemsForModulo(item) {
        /** @type {?} */
        let newItem = [item];
        /** @type {?} */
        const parent = this.modulos.find((/**
         * @param {?} modulo
         * @return {?}
         */
        modulo => `${modulo.id}` === item.id));
        if (parent) {
            /** @type {?} */
            const newMenuItem = (/** @type {?} */ ({
                id: `${parent.pai}`,
                label: parent.nome
            }));
            if (parent.tipo === TIPO_MODULO.ITEM_DE_MENU && parent.acao) {
                newMenuItem.routerLink = parent.acao;
            }
            newItem = newItem.concat(this.getItemsForModulo(newMenuItem));
        }
        return newItem;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.subscriptionModulos) {
            this.subscriptionModulos.unsubscribe();
        }
    }
}
SearchNavItemComponent.ɵfac = function SearchNavItemComponent_Factory(t) { return new (t || SearchNavItemComponent)(ɵngcc0.ɵɵdirectiveInject(Wso2IntegrationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router)); };
SearchNavItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SearchNavItemComponent, selectors: [["mapa-search-nav-item"]], outputs: { changeRouter: "changeRouter" }, decls: 3, vars: 5, consts: [[1, "search-nav-item"], ["field", "label", "name", "search", 3, "ngModel", "suggestions", "placeholder", "completeMethod", "onSelect", "ngModelChange"]], template: function SearchNavItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "p-autoComplete", 1);
        ɵngcc0.ɵɵlistener("completeMethod", function SearchNavItemComponent_Template_p_autoComplete_completeMethod_1_listener($event) { return ctx.search($event); })("onSelect", function SearchNavItemComponent_Template_p_autoComplete_onSelect_1_listener($event) { return ctx.onSelect($event); })("ngModelChange", function SearchNavItemComponent_Template_p_autoComplete_ngModelChange_1_listener($event) { return ctx.searchMenu = $event; });
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchMenu)("suggestions", ctx.resultsMenu)("placeholder", ɵngcc0.ɵɵpipeBind1(2, 3, "CORE.HEADER.NAVBAR.SEARCH_NAV"));
    } }, directives: [ɵngcc4.ɵangular_packages_forms_forms_y, ɵngcc4.NgControlStatusGroup, ɵngcc4.NgForm, ɵngcc20.AutoComplete, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], pipes: [ɵngcc11.TranslatePipe], encapsulation: 2 });
/** @nocollapse */
SearchNavItemComponent.ctorParameters = () => [
    { type: Wso2IntegrationService },
    { type: Router }
];
SearchNavItemComponent.propDecorators = {
    changeRouter: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SearchNavItemComponent, [{
        type: Component,
        args: [{
                selector: 'mapa-search-nav-item',
                template: "<form class=\"search-nav-item\">\r\n    <p-autoComplete (completeMethod)=\"search($event)\" (onSelect)=\"onSelect($event)\" [(ngModel)]=\"searchMenu\"\r\n                    [suggestions]=\"resultsMenu\" field=\"label\" name=\"search\"\r\n                    [placeholder]=\"'CORE.HEADER.NAVBAR.SEARCH_NAV' | translate\"></p-autoComplete>\r\n</form>\r\n"
            }]
    }], function () { return [{ type: Wso2IntegrationService }, { type: ɵngcc3.Router }]; }, { changeRouter: [{
            type: Output
        }] }); })();
if (false) {
    /** @type {?} */
    SearchNavItemComponent.prototype.resultsMenu;
    /** @type {?} */
    SearchNavItemComponent.prototype.searchMenu;
    /** @type {?} */
    SearchNavItemComponent.prototype.placeholder;
    /** @type {?} */
    SearchNavItemComponent.prototype.changeRouter;
    /**
     * @type {?}
     * @private
     */
    SearchNavItemComponent.prototype.modulos;
    /**
     * @type {?}
     * @private
     */
    SearchNavItemComponent.prototype.subscriptionModulos;
    /**
     * @type {?}
     * @private
     */
    SearchNavItemComponent.prototype.wso2IntegrationService;
    /**
     * @type {?}
     * @private
     */
    SearchNavItemComponent.prototype.route;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/directives/hide-for-groups.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HideForGroupsDirective {
    /**
     * @param {?} templateRef
     * @param {?} vcRef
     * @param {?} wso2IntegrationService
     */
    constructor(templateRef, vcRef, wso2IntegrationService) {
        this.templateRef = templateRef;
        this.vcRef = vcRef;
        this.wso2IntegrationService = wso2IntegrationService;
    }
    /**
     * @param {?} profiles
     * @return {?}
     */
    set hideForGroups(profiles) {
        this.wso2IntegrationService.usuario.subscribe({
            next: (/**
             * @param {?} usuario
             * @return {?}
             */
            usuario => {
                if (usuario && usuario.idUsuario) {
                    if (!Array.isArray(profiles)) {
                        profiles = [profiles];
                    }
                    if (usuario.hasAnyPerfil(profiles)) {
                        this.vcRef.clear();
                    }
                    else {
                        this.vcRef.createEmbeddedView(this.templateRef);
                    }
                }
                else {
                    console.log('Não foi identificado perfil/grupo para o usuário atual, por isso o componente será renderizado...');
                    this.vcRef.createEmbeddedView(this.templateRef);
                }
            })
        });
    }
}
HideForGroupsDirective.ɵfac = function HideForGroupsDirective_Factory(t) { return new (t || HideForGroupsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(Wso2IntegrationService)); };
HideForGroupsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: HideForGroupsDirective, selectors: [["", "hideForGroups", ""]], inputs: { hideForGroups: "hideForGroups" } });
/** @nocollapse */
HideForGroupsDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: Wso2IntegrationService }
];
HideForGroupsDirective.propDecorators = {
    hideForGroups: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HideForGroupsDirective, [{
        type: Directive,
        args: [{
                selector: '[hideForGroups]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: Wso2IntegrationService }]; }, { hideForGroups: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    HideForGroupsDirective.prototype.templateRef;
    /**
     * @type {?}
     * @private
     */
    HideForGroupsDirective.prototype.vcRef;
    /**
     * @type {?}
     * @private
     */
    HideForGroupsDirective.prototype.wso2IntegrationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/directives/show-for-groups.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ShowForGroupsDirective {
    /**
     * @param {?} templateRef
     * @param {?} vcRef
     * @param {?} wso2IntegrationService
     */
    constructor(templateRef, vcRef, wso2IntegrationService) {
        this.templateRef = templateRef;
        this.vcRef = vcRef;
        this.wso2IntegrationService = wso2IntegrationService;
    }
    /**
     * @param {?} profiles
     * @return {?}
     */
    set showForGroups(profiles) {
        this.wso2IntegrationService.usuario.subscribe({
            next: (/**
             * @param {?} usuario
             * @return {?}
             */
            usuario => {
                if (usuario && usuario.idUsuario) {
                    if (!Array.isArray(profiles)) {
                        profiles = [profiles];
                    }
                    if (usuario.hasAnyPerfil(profiles)) {
                        this.vcRef.createEmbeddedView(this.templateRef);
                    }
                    else {
                        this.vcRef.clear();
                    }
                }
                else {
                    console.log('Não foi identificado perfil/grupo para o usuário atual, por isso o componente será renderizado...');
                    this.vcRef.createEmbeddedView(this.templateRef);
                }
            })
        });
    }
}
ShowForGroupsDirective.ɵfac = function ShowForGroupsDirective_Factory(t) { return new (t || ShowForGroupsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(Wso2IntegrationService)); };
ShowForGroupsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ShowForGroupsDirective, selectors: [["", "showForGroups", ""]], inputs: { showForGroups: "showForGroups" } });
/** @nocollapse */
ShowForGroupsDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: Wso2IntegrationService }
];
ShowForGroupsDirective.propDecorators = {
    showForGroups: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ShowForGroupsDirective, [{
        type: Directive,
        args: [{
                selector: '[showForGroups]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: Wso2IntegrationService }]; }, { showForGroups: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ShowForGroupsDirective.prototype.templateRef;
    /**
     * @type {?}
     * @private
     */
    ShowForGroupsDirective.prototype.vcRef;
    /**
     * @type {?}
     * @private
     */
    ShowForGroupsDirective.prototype.wso2IntegrationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/layout/admin-layout/admin-layout.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AdminLayoutComponent {
    constructor() {
        this.show$ = new BehaviorSubject(false);
        // Só exibe após a configuração ser definida pela aplicação
        MapaEnviromentService.get((/**
         * @return {?}
         */
        () => {
            this.show$.next(true);
        }));
    }
}
AdminLayoutComponent.ɵfac = function AdminLayoutComponent_Factory(t) { return new (t || AdminLayoutComponent)(); };
AdminLayoutComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AdminLayoutComponent, selectors: [["mapa-admin-layout"]], decls: 2, vars: 3, consts: [[4, "ngIf"], [1, "mapa-content-container"]], template: function AdminLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AdminLayoutComponent_div_0_Template, 4, 0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.show$));
    } }, directives: [ɵngcc8.NgIf, HeaderComponent, ɵngcc3.RouterOutlet], pipes: [ɵngcc8.AsyncPipe], styles: [""] });
/** @nocollapse */
AdminLayoutComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AdminLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'mapa-admin-layout',
                template: "<div *ngIf=\"(show$ | async)\">\r\n    <mapa-header></mapa-header>\r\n    <div class=\"mapa-content-container\">\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    AdminLayoutComponent.prototype.show$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/layout/blank-layout/blank-layout.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BlankLayoutComponent {
    constructor() {
        this.show$ = new BehaviorSubject(false);
        // Só exibe após a configuração ser definida pela aplicação
        MapaEnviromentService.get((/**
         * @return {?}
         */
        () => {
            this.show$.next(true);
        }));
    }
}
BlankLayoutComponent.ɵfac = function BlankLayoutComponent_Factory(t) { return new (t || BlankLayoutComponent)(); };
BlankLayoutComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlankLayoutComponent, selectors: [["mapa-blank-layout"]], decls: 2, vars: 3, consts: [[4, "ngIf"]], template: function BlankLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BlankLayoutComponent_div_0_Template, 2, 0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.show$));
    } }, directives: [ɵngcc8.NgIf, ɵngcc3.RouterOutlet], pipes: [ɵngcc8.AsyncPipe], styles: [""] });
/** @nocollapse */
BlankLayoutComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlankLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'mapa-blank-layout',
                template: "<div *ngIf=\"(show$ | async)\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    BlankLayoutComponent.prototype.show$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/ui/ui.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const UiRoutes = [];
class UiModule {
}
UiModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: UiModule });
UiModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function UiModule_Factory(t) { return new (t || UiModule)(); }, imports: [[
            TranslateModule,
            FormsModule,
            AutoCompleteModule,
            AvatarModule,
            CommonModule,
            RouterModule.forChild(UiRoutes),
            SidebarModule,
            SlideMenuModule,
            DropdownModule,
            MenubarModule,
            ButtonModule,
            InputTextModule,
            BreadcrumbModule,
            PanelMenuModule,
            ProgressBarModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UiModule, { declarations: function () { return [BlankLayoutComponent, AdminLayoutComponent, PublicLayoutComponent, NavBarComponent, SearchNavItemComponent, BreadcrumbComponent, HeaderComponent, ShowForGroupsDirective, HideForGroupsDirective]; }, imports: function () { return [TranslateModule,
        FormsModule,
        AutoCompleteModule,
        AvatarModule,
        CommonModule, ɵngcc3.RouterModule, SidebarModule,
        SlideMenuModule,
        DropdownModule,
        MenubarModule,
        ButtonModule,
        InputTextModule,
        BreadcrumbModule,
        PanelMenuModule,
        ProgressBarModule]; }, exports: function () { return [BlankLayoutComponent, AdminLayoutComponent, PublicLayoutComponent, ShowForGroupsDirective, HideForGroupsDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UiModule, [{
        type: NgModule,
        args: [{
                imports: [
                    TranslateModule,
                    FormsModule,
                    AutoCompleteModule,
                    AvatarModule,
                    CommonModule,
                    RouterModule.forChild(UiRoutes),
                    SidebarModule,
                    SlideMenuModule,
                    DropdownModule,
                    MenubarModule,
                    ButtonModule,
                    InputTextModule,
                    BreadcrumbModule,
                    PanelMenuModule,
                    ProgressBarModule
                ],
                declarations: [
                    BlankLayoutComponent,
                    AdminLayoutComponent,
                    PublicLayoutComponent,
                    NavBarComponent,
                    SearchNavItemComponent,
                    BreadcrumbComponent,
                    HeaderComponent,
                    ShowForGroupsDirective,
                    HideForGroupsDirective
                ],
                exports: [
                    BlankLayoutComponent,
                    AdminLayoutComponent,
                    PublicLayoutComponent,
                    ShowForGroupsDirective,
                    HideForGroupsDirective
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/shared.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SharedModule {
}
SharedModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SharedModule });
SharedModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SharedModule_Factory(t) { return new (t || SharedModule)(); }, imports: [[UiModule], UiModule, TranslateModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharedModule, { imports: function () { return [UiModule]; }, exports: function () { return [UiModule, TranslateModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SharedModule, [{
        type: NgModule,
        args: [{
                imports: [UiModule],
                exports: [UiModule, TranslateModule]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/helpers/lang.interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Se o usuário selecionar um idioma, envia em todas as requisições essa solicitação
 */
class LanguageInterceptor {
    /**
     * @param {?} languageService
     */
    constructor(languageService) {
        this.languageService = languageService;
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    intercept(request, next) {
        /** @type {?} */
        const lang = this.languageService.getCurrentLanguage();
        if (lang && lang.code) {
            request = request.clone({
                setHeaders: {
                    'Accept-Language': `${lang.code}`
                }
            });
        }
        return next.handle(request);
    }
}
LanguageInterceptor.ɵfac = function LanguageInterceptor_Factory(t) { return new (t || LanguageInterceptor)(ɵngcc0.ɵɵinject(LanguageService)); };
LanguageInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LanguageInterceptor, factory: LanguageInterceptor.ɵfac });
/** @nocollapse */
LanguageInterceptor.ctorParameters = () => [
    { type: LanguageService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LanguageInterceptor, [{
        type: Injectable
    }], function () { return [{ type: LanguageService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    LanguageInterceptor.prototype.languageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/helpers/jwt.interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const regexIgnore = /\.(ico|js|json|png|jpg|jpeg|css|ttf|woff2)$/;
/**
 * Em toda requisição informa o token atual
 */
class JwtInterceptor {
    /**
     * @param {?} http
     * @param {?} wso2IntegrationService
     */
    constructor(http, wso2IntegrationService) {
        this.http = http;
        this.wso2IntegrationService = wso2IntegrationService;
        this.refreshTokenInProgress = false;
        this.refreshTokenSubject = new BehaviorSubject(null);
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    intercept(request, next) {
        /** @type {?} */
        const skipAuth = 'true' === request.headers.get('skipAuth');
        // Ignora o uso do token em algumas requisições específicas
        if (skipAuth || request.url.indexOf('/MapaAuthorization/1.0.0/') > 0 || regexIgnore.test(request.url) || request.url.endsWith('/token')) {
            return next.handle(request);
        }
        request = this.addAuthenticationToken(request);
        return next.handle(request).pipe(catchError((/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            // {"fault": {
            //     "code": 900901,
            //     "message": "Invalid Credentials",
            //     "description": "Access failure for API: /comex/1.0.0, version: 1.0.0 status: (900901) - Invalid Credentials. Make sure you have given the correct access token"
            // }}
            /** @type {?} */
            const body = error.error;
            if (error.status === 401 && body && body.fault && body.fault.code === 900901) {
                console.error('Erro: 401 - Unauthorized | Um novo "access token" será gerado e a requisição será executada mais uma vez', body);
                if (this.refreshTokenInProgress) {
                    return this.refreshTokenSubject.pipe(filter((/**
                     * @param {?} result
                     * @return {?}
                     */
                    result => result !== null)), take(1), switchMap((/**
                     * @return {?}
                     */
                    () => next.handle(this.addAuthenticationToken(request)))));
                }
                else {
                    this.refreshTokenInProgress = true;
                    this.refreshTokenSubject.next(null);
                    return this.refreshAccessToken().pipe(switchMap((/**
                     * @param {?} success
                     * @return {?}
                     */
                    (success) => {
                        this.refreshTokenSubject.next(success);
                        return next.handle(this.addAuthenticationToken(request));
                    })), finalize((/**
                     * @return {?}
                     */
                    () => this.refreshTokenInProgress = false)));
                }
            }
            else {
                return throwError(error);
            }
        })));
    }
    /**
     * @private
     * @param {?} request
     * @return {?}
     */
    addAuthenticationToken(request) {
        /** @type {?} */
        const config = MapaEnviromentService.get();
        /** @type {?} */
        const tokenJWT = this.wso2IntegrationService.getTokenJWT();
        /** @type {?} */
        const jwt = this.wso2IntegrationService.getJWT();
        /** @type {?} */
        const headers = {};
        /** @type {?} */
        let newHeaders = false;
        // No ambiente local adiciona o cabeçalho que é criado pelo WSO2 com o token jwt
        if (config.localUrl && config.ambiente.toLowerCase() === 'local' && request.url.startsWith(config.localUrl)) {
            newHeaders = true;
            headers['MAPA-JWT-ASSERTION'] = `Bearer ${tokenJWT}`;
        }
        else if (jwt && jwt.ACCESS_TOKEN) {
            newHeaders = true;
            headers['Authorization'] = `Bearer ${jwt.ACCESS_TOKEN}`;
        }
        if (newHeaders) {
            return request.clone({
                setHeaders: headers
            });
        }
        return request;
    }
    /**
     * @private
     * @return {?}
     */
    refreshAccessToken() {
        /** @type {?} */
        const config = MapaEnviromentService.get();
        /** @type {?} */
        const jwt = this.wso2IntegrationService.getJWT();
        /** @type {?} */
        const urlGetToken = config.wso2Url.endsWith('/') ? config.wso2Url + 'token' : config.wso2Url + '/token';
        return fromFetch(urlGetToken, {
            method: 'POST',
            body: 'grant_type=client_credentials',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Basic ' + jwt.BASIC
            }
        }).pipe(switchMap((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            if (response.ok) {
                return from(response.json());
            }
            else {
                return throwError({ status: `${response.status} - ${response.statusText}`, message: `${response.text()}` });
            }
        })), map((/**
         * @param {?} data
         * @return {?}
         */
        (data) => this.wso2IntegrationService.changeAccessToken(data.access_token))), map((/**
         * @return {?}
         */
        () => true)), catchError((/**
         * @param {?} err
         * @return {?}
         */
        err => {
            console.error(err);
            return throwError({ message: err.message });
        })));
    }
}
JwtInterceptor.ɵfac = function JwtInterceptor_Factory(t) { return new (t || JwtInterceptor)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(Wso2IntegrationService)); };
JwtInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: JwtInterceptor, factory: JwtInterceptor.ɵfac });
/** @nocollapse */
JwtInterceptor.ctorParameters = () => [
    { type: HttpClient },
    { type: Wso2IntegrationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JwtInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Wso2IntegrationService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    JwtInterceptor.prototype.refreshTokenInProgress;
    /**
     * @type {?}
     * @private
     */
    JwtInterceptor.prototype.refreshTokenSubject;
    /**
     * @type {?}
     * @private
     */
    JwtInterceptor.prototype.http;
    /**
     * @type {?}
     * @private
     */
    JwtInterceptor.prototype.wso2IntegrationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/mapa-core.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
registerLocaleData(localePt, 'pt', localePtExtra);
// AoT requires an exported function for factories
/**
 * @param {?} http
 * @return {?}
 */
function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, 'assets/i18n/');
}
class MapaCoreInternalModule {
}
MapaCoreInternalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MapaCoreInternalModule });
MapaCoreInternalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MapaCoreInternalModule_Factory(t) { return new (t || MapaCoreInternalModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            HttpClientModule,
            AuthModule,
            SharedModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                }
            }),
            OAuthModule.forRoot()
        ], CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule, AuthModule, SharedModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MapaCoreInternalModule, { imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule, AuthModule, SharedModule, ɵngcc11.TranslateModule, ɵngcc2.OAuthModule]; }, exports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule, AuthModule, SharedModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MapaCoreInternalModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    AuthModule,
                    SharedModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useFactory: HttpLoaderFactory,
                            deps: [HttpClient]
                        }
                    }),
                    OAuthModule.forRoot()
                ],
                exports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    AuthModule,
                    SharedModule
                ]
            }]
    }], null, null); })();
class MapaCoreModule {
    /**
     * @param {?} translate
     * @param {?} wso2IntegrationService
     */
    constructor(translate, wso2IntegrationService) {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('pt-br');
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use('pt-br');
    }
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: MapaCoreInternalModule,
            providers: [
                { provide: LOCALE_ID, useValue: 'pt' },
                { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
                { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true }
            ]
        };
    }
    /**
     * Inicio da aplicação.
     *
     * Deve ser invocado no main.ts da aplicação final.
     *
     * Faz o carregamento do enviroment.json a partir do ambiente de execução (Docker)
     * @template M
     * @param {?} defaultEnvironment
     * @return {?}
     */
    static loadEnvironment(defaultEnvironment) {
        /** @type {?} */
        const promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const xmlhttp = new XMLHttpRequest();
            /** @type {?} */
            const method = 'GET';
            /** @type {?} */
            const url = 'assets/environment.json';
            xmlhttp.open(method, url, true);
            xmlhttp.onload = (/**
             * @return {?}
             */
            () => {
                if (xmlhttp.status === 200) {
                    resolve(JSON.parse(xmlhttp.responseText));
                }
                else {
                    resolve(defaultEnvironment);
                }
            });
            xmlhttp.send();
        }));
        return promise.then((/**
         * @param {?} envJson
         * @return {?}
         */
        envJson => {
            if (envJson.production) {
                enableProdMode();
            }
            // Faz a copia de todos os parametros de ambiente para a configuração atual
            if (envJson.mapa) {
                // tslint:disable-next-line
                for (const a in envJson.mapa) {
                    if (!envJson.mapa.hasOwnProperty(a)) {
                        continue;
                    }
                    defaultEnvironment.mapa[a] = envJson.mapa[a];
                }
            }
            if (!defaultEnvironment.mapa.sso) {
                throw new Error('A configuração "sso" não foi definido no enviroment.json');
            }
            MapaEnviromentService.set(defaultEnvironment.mapa);
            if (defaultEnvironment.mapa.debug) {
                console.log('@mapa/core: environment', defaultEnvironment);
            }
        }));
    }
}
MapaCoreModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MapaCoreModule });
MapaCoreModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MapaCoreModule_Factory(t) { return new (t || MapaCoreModule)(ɵngcc0.ɵɵinject(ɵngcc11.TranslateService), ɵngcc0.ɵɵinject(Wso2IntegrationService)); }, providers: [
        { provide: LOCALE_ID, useValue: 'pt' }
    ], imports: [[CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, SharedModule], CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, SharedModule] });
/** @nocollapse */
MapaCoreModule.ctorParameters = () => [
    { type: TranslateService },
    { type: Wso2IntegrationService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MapaCoreModule, { imports: function () { return [CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, SharedModule]; }, exports: function () { return [CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, SharedModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MapaCoreModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, SharedModule],
                exports: [CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, SharedModule],
                providers: [
                    { provide: LOCALE_ID, useValue: 'pt' }
                ]
            }]
    }], function () { return [{ type: ɵngcc11.TranslateService }, { type: Wso2IntegrationService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/guards/auth.guard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthGuard {
    /**
     * @param {?} router
     * @param {?} wso2IntegrationService
     */
    constructor(router, wso2IntegrationService) {
        this.router = router;
        this.wso2IntegrationService = wso2IntegrationService;
        this.subscriptionModulos = this.wso2IntegrationService.modulos.subscribe({
            next: (/**
             * @param {?} modulos
             * @return {?}
             */
            modulos => this.modulos = modulos || [])
        });
    }
    /**
     * @private
     * @param {?} route
     * @return {?}
     */
    static getRouteConfig(route) {
        /** @type {?} */
        let routeConfig = '';
        /** @type {?} */
        let currentRoute = route;
        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
            if (!!currentRoute.routeConfig && !!currentRoute.routeConfig.path) {
                routeConfig += ('/' + currentRoute.routeConfig.path);
            }
        }
        return routeConfig;
    }
    /**
     * @param {?} childRoute
     * @param {?} state
     * @return {?}
     */
    canActivateChild(childRoute, state) {
        return this.canActivate(childRoute, state);
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivate(route, state) {
        return this.wso2IntegrationService.usuario.pipe(filter((/**
         * @param {?} value
         * @return {?}
         */
        value => !!value)), take(1), map((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const url = state.url;
            /** @type {?} */
            const routeConfig = AuthGuard.getRouteConfig(state.root);
            /** @type {?} */
            const result = ['', '/'].includes(routeConfig) || !!this.modulos.find((/**
             * @param {?} modulo
             * @return {?}
             */
            modulo => modulo.acao === routeConfig));
            if (!result) {
                console.error(`AuthGuard::canActivate() -> SEM PERMISSÃO DE ACESSO | routeConfig: "${routeConfig}" | url: "${url}"`);
            }
            return result;
        })));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.subscriptionModulos) {
            this.subscriptionModulos.unsubscribe();
        }
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(ɵngcc3.Router), ɵngcc0.ɵɵinject(Wso2IntegrationService)); };
/** @nocollapse */
AuthGuard.ctorParameters = () => [
    { type: Router },
    { type: Wso2IntegrationService }
];
/** @nocollapse */ AuthGuard.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(ɵɵinject(Router), ɵɵinject(Wso2IntegrationService)); }, token: AuthGuard, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc3.Router }, { type: Wso2IntegrationService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthGuard.prototype.modulos;
    /**
     * @type {?}
     * @private
     */
    AuthGuard.prototype.subscriptionModulos;
    /**
     * @type {?}
     * @private
     */
    AuthGuard.prototype.router;
    /**
     * @type {?}
     * @private
     */
    AuthGuard.prototype.wso2IntegrationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/model/config.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function MapaCoreConfig() { }
if (false) {
    /** @type {?} */
    MapaCoreConfig.prototype.contexto;
    /** @type {?|undefined} */
    MapaCoreConfig.prototype.idiomas;
    /** @type {?|undefined} */
    MapaCoreConfig.prototype.debug;
    /** @type {?} */
    MapaCoreConfig.prototype.wso2Url;
    /** @type {?|undefined} */
    MapaCoreConfig.prototype.ambiente;
    /**
     * Quando o ambiente = 'Local', as consultas as API's são substituidas em tempo de execução
     * Ex. "http://localhost:8080/sigpoa_api",
     * @type {?|undefined}
     */
    MapaCoreConfig.prototype.localUrl;
    /**
     * Informações para login no WSO2
     * @type {?|undefined}
     */
    MapaCoreConfig.prototype.sso;
    /**
     * No ambiente local, permite trabalhar com dados simulados, sem necessidade de integraçao com o WSO2
     * @type {?|undefined}
     */
    MapaCoreConfig.prototype.mock;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/authentication.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthenticationService {
    /**
     * @param {?} wso2IntegrationService
     */
    constructor(wso2IntegrationService) {
        this.wso2IntegrationService = wso2IntegrationService;
        this.wso2IntegrationService.usuario.subscribe({
            next: (/**
             * @param {?} usuario
             * @return {?}
             */
            usuario => {
                this.usuario = usuario;
            })
        });
    }
    /**
     * @return {?}
     */
    getUsuarioLogado() {
        return this.usuario;
    }
    /**
     * @param {?} perfil
     * @return {?}
     */
    hasPerfil(perfil) {
        return !!this.usuario && this.usuario.hasPerfil(perfil);
    }
    /**
     * @param {?} perfis
     * @return {?}
     */
    hasAnyPerfil(perfis) {
        return !!this.usuario && this.usuario.hasAnyPerfil(perfis);
    }
}
AuthenticationService.ɵfac = function AuthenticationService_Factory(t) { return new (t || AuthenticationService)(ɵngcc0.ɵɵinject(Wso2IntegrationService)); };
AuthenticationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthenticationService, factory: AuthenticationService.ɵfac });
/** @nocollapse */
AuthenticationService.ctorParameters = () => [
    { type: Wso2IntegrationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationService, [{
        type: Injectable
    }], function () { return [{ type: Wso2IntegrationService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.usuario;
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.wso2IntegrationService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: mapa-core.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AdminLayoutComponent, AuthGuard, AuthenticationService, BlankLayoutComponent, HttpLoaderFactory, LanguageService, MapaCoreInternalModule, MapaCoreModule, MapaEnviromentService, PublicLayoutComponent, SharedModule, Usuario, WSO2, WSO2Client, Wso2IntegrationService, AuthModule as ɵa, authRoutes as ɵb, AuthRouting as ɵc, AuthComponent as ɵd, AplicacaoAPI as ɵe, GruposAPI as ɵf, ModulosAPI as ɵg, UiRoutes as ɵh, UiModule as ɵi, NavBarComponent as ɵj, SearchNavItemComponent as ɵk, BreadcrumbComponent as ɵl, HeaderComponent as ɵm, ShowForGroupsDirective as ɵn, HideForGroupsDirective as ɵo, JwtInterceptor as ɵp, LanguageInterceptor as ɵq };

//# sourceMappingURL=mapa-core.js.map